// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../fonts/fjallaone-regular-webfont.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../fonts/fjallaone-regular-webfont.woff", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  padding: 0;
  margin: 0;
}

@font-face {
  font-family: "fjalla_oneregular";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff");
  font-weight: normal;
  font-style: normal;
}
html,
body {
  height: 100%;
  padding: 0;
  margin: 0;
  background-color: #fff;
  font-family: "Open Sans", Helvetica, Arial, sans-serif;
  color: #565656;
}

div {
  box-sizing: border-box;
}

div,
p {
  font-family: "Open Sans", Helvetica, Arial, sans-serif;
  color: #6f6f6f;
}

a {
  text-decoration: none;
  color: #1f75de;
}

img {
  max-width: 100%;
}

input[type=text],
input[type=email],
input[type=password],
input[type=number] {
  outline: none;
  appearance: textfield;
}
input[type=text]:focus,
input[type=email]:focus,
input[type=password]:focus,
input[type=number]:focus {
  box-shadow: none;
  outline: none;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

input[type=checkbox]:focus {
  box-shadow: none;
  outline: none;
}

textarea {
  resize: none;
}
textarea:focus {
  box-shadow: none;
  outline: none;
}

.main-wrapper {
  width: 100%;
}

.social-links {
  height: 50px;
  box-shadow: 0px 5px 10px 0px rgba(202, 202, 202, 0.3);
  -webkit-box-shadow: 0px 5px 10px 0px rgba(202, 202, 202, 0.3);
  -moz-box-shadow: 0px 5px 10px 0px rgba(202, 202, 202, 0.3);
  position: relative;
  z-index: 2;
  background-color: #f9fbff;
}
.social-links .container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 100%;
}
.social-links .container .links-left {
  display: flex;
  align-items: center;
  height: 100%;
}
.social-links .container .links-left ul {
  padding: 0;
  margin: 0;
  list-style: none;
}
.social-links .container .links-left ul li {
  display: inline-flex;
  align-items: center;
  margin-right: 30px;
}
@media (max-width: 767px) {
  .social-links .container .links-left ul li {
    margin-right: 10px;
  }
}
.social-links .container .links-left ul li a {
  color: #565656;
}
@media (max-width: 767px) {
  .social-links .container .links-left ul li a span {
    display: none;
  }
}
.social-links .container .links-left ul li i.bi {
  margin-right: 10px;
}
.social-links .container .links-right {
  display: flex;
  height: 100%;
}
.social-links .container .links-right ul {
  padding: 0;
  margin: 0;
  list-style: none;
}
.social-links .container .links-right ul li {
  display: inline-flex;
  align-items: center;
  margin-right: 25px;
  height: 100%;
}
@media (max-width: 767px) {
  .social-links .container .links-right ul li {
    margin-right: 10px;
  }
}
.social-links .container .links-right ul li:last-child {
  margin-right: 0;
}
.social-links .container .links-right ul li a {
  color: #565656;
}
.social-links .container .links-right ul li a i.bi {
  font-size: 22px;
  color: #000;
}
.social-links .container .links-right ul li a i.bi:hover {
  color: #205da8;
}

.sticky-navbar {
  background: #fff;
  width: 100%;
  position: sticky;
  top: 0;
  z-index: 100;
  border-bottom: 1px solid #e3e3e3;
}

.banner-wrapper {
  background: #f2f5fc;
  width: 100%;
}
.banner-wrapper .banner-panel {
  display: flex;
  align-items: center;
}
@media (max-width: 990px) {
  .banner-wrapper .banner-panel {
    flex-direction: column;
  }
}
.banner-wrapper .banner-panel .banner-left {
  width: 41%;
}
@media (min-width: 1024px) and (max-width: 1200px) {
  .banner-wrapper .banner-panel .banner-left {
    width: 50%;
  }
}
@media (max-width: 990px) {
  .banner-wrapper .banner-panel .banner-left {
    width: 100%;
    text-align: center;
    order: 2;
    margin: 40px auto;
  }
}
.banner-wrapper .banner-panel .banner-left h2 {
  font-family: "fjalla_oneregular", Helvetica, Arial, sans-serif;
  font-size: 45px;
  line-height: 65px;
  color: #000;
  margin-bottom: 20px;
}
@media (min-width: 990px) and (max-width: 1200px) {
  .banner-wrapper .banner-panel .banner-left h2 {
    font-size: 35px;
    line-height: 50px;
    margin-bottom: 10px;
  }
}
.banner-wrapper .banner-panel .banner-left p {
  margin-bottom: 30px;
}
.banner-wrapper .banner-panel .banner-right {
  width: 60%;
}
@media (min-width: 1024px) and (max-width: 1200px) {
  .banner-wrapper .banner-panel .banner-right {
    width: 50%;
  }
}
@media (max-width: 990px) {
  .banner-wrapper .banner-panel .banner-right {
    width: 100%;
    text-align: center;
  }
}
.banner-wrapper .banner-panel .banner-right img {
  max-width: 100%;
}

@media (max-width: 767px) {
  .logo-menu {
    justify-content: space-between !important;
  }
}
.logo-menu .navbar-toggler {
  border: none;
  padding: 0;
  width: 50px;
}
.logo-menu .navbar-toggler:focus {
  outline: none;
  border: none;
  box-shadow: none;
}

.menubar {
  display: flex;
  align-items: center;
  flex-grow: unset;
}
@media (max-width: 767px) {
  .menubar {
    flex-direction: column;
    align-items: flex-start;
    background-color: #fff;
    padding: 15px;
    border: 1px solid #ccc;
    position: fixed;
    width: 94%;
    top: 128px;
  }
}
@media (min-width: 768px) and (max-width: 990px) {
  .menubar {
    margin-top: 30px;
  }
}
.menubar li {
  margin-right: 50px;
}
@media (max-width: 1200px) {
  .menubar li {
    margin-right: 15px;
  }
}
@media (min-width: 1200px) and (max-width: 1366px) {
  .menubar li {
    margin-right: 25px;
  }
}
@media (min-width: 768px) and (max-width: 990px) {
  .menubar li {
    margin-right: 10px;
  }
}
@media (max-width: 767px) {
  .menubar li {
    margin-right: 0;
    margin-bottom: 20px;
  }
}
.menubar li:last-child {
  margin-right: 0;
}
.menubar li a {
  padding: 0;
  font-family: "fjalla_oneregular", Helvetica, Arial, sans-serif;
  text-transform: uppercase;
  font-size: 18px;
  color: #205da8;
}
@media (max-width: 1200px) {
  .menubar li a {
    font-size: 13px;
  }
}
@media (min-width: 768px) and (max-width: 990px) {
  .menubar li a {
    font-size: 11px;
  }
}
.menubar li a:hover, .menubar li a.active {
  color: #000;
}
.menubar li a.login-link {
  background: #205da8;
  border-radius: 20px;
  font-size: 18px;
  text-transform: uppercase;
  padding: 8px 30px !important;
  color: #fff;
}
.menubar li a.login-link:hover {
  background: #000;
  color: #fff;
}
.menubar li.profile-link {
  font-family: "fjalla_oneregular", Helvetica, Arial, sans-serif;
  font-size: 16px;
  color: #2e2e2e;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  display: flex;
  align-items: center;
}
.menubar li.profile-link span {
  color: #808080;
  margin-left: 5px;
}
.menubar li.profile-link .profile-icon {
  width: 48px;
  height: 48px;
  border-radius: 100%;
  border: 1px solid #d6d6d6;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: #fff;
  margin-left: 10px;
  cursor: pointer;
}
.menubar li.profile-link .profile-icon img {
  max-height: 40px;
  max-width: 40px;
}
.menubar li.profile-link .dropdown-menu li {
  text-align: right;
  padding: 5px 10px;
  margin-right: 0;
}
.menubar li.profile-link .dropdown-menu li a {
  font-family: "Open Sans", Helvetica, Arial, sans-serif;
  font-size: 14px;
  color: #000;
  text-transform: none;
}

.about-section {
  padding: 40px 0px;
}
.about-section h3 {
  color: #205da8;
  font-size: 22px;
  margin: 0px 0px 20px 0px;
  font-family: "fjalla_oneregular", Helvetica, Arial, sans-serif;
  letter-spacing: 0.5px;
}
@media (max-width: 767px) {
  .about-section h3 {
    font-size: 16px;
  }
}
.about-section p {
  line-height: 28px;
}
.about-section .home-about-img img {
  width: 95%;
}
@media (max-width: 990px) {
  .about-section .home-about-img {
    text-align: center;
    margin-bottom: 30px;
  }
}
.about-section .read-more {
  text-align: right;
}
.about-section .read-more a {
  color: #205da8;
}
.about-section .highlight-text {
  text-align: center;
  font-size: 18px;
  font-style: italic;
  color: #000;
}
.about-section .home-about-cont p {
  line-height: 28px;
}
.about-section .home-about-cont ul {
  padding: 0;
  margin: 0 0 0 15px;
  list-style: none;
}
.about-section .home-about-cont ul li {
  padding-bottom: 10px;
  line-height: 26px;
  display: flex;
  align-items: center;
}
.about-section .home-about-cont ul li svg {
  margin-right: 5px;
}

.services-section {
  background: #f2f5fc;
  padding: 40px 0px 0px 0px;
}
.services-section .service-img {
  text-align: center;
}
@media (min-width: 1440px) {
  .services-section .service-img {
    width: 40%;
  }
}
.services-section .home-service-cont {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}
@media (min-width: 1440px) {
  .services-section .home-service-cont {
    width: 60%;
    padding-left: 5%;
  }
}
@media (max-width: 990px) {
  .services-section .home-service-cont {
    margin: 30px auto;
  }
}
.services-section .home-service-cont .service-col {
  width: 50%;
  padding-bottom: 20px;
  padding-right: 20px;
}
.services-section .home-service-cont .service-col img {
  margin-bottom: 10px;
}
.services-section .home-service-cont .service-col h2 {
  color: #205da8;
  font-size: 20px;
  font-family: "fjalla_oneregular", Helvetica, Arial, sans-serif;
  margin-bottom: 15px;
  margin-bottom: 10px;
}
.services-section .home-service-cont .service-col p {
  font-size: 14px;
  font-family: "Open Sans", Helvetica, Arial, sans-serif;
  line-height: 24px;
  margin-bottom: 10px;
}
.services-section .home-service-cont .service-col a {
  color: #205da8;
  font-size: 12px;
  text-transform: uppercase;
  border-bottom: 1px solid #205da8;
}
.services-section .home-service-cont .service-col a:hover {
  border-bottom: none;
}

.service-img {
  text-align: center;
  margin: 40px auto;
}
.service-img img {
  max-width: 100%;
}

.contact-section {
  display: flex;
  flex-direction: row;
  width: 100%;
  margin-top: 30px;
}
@media (max-width: 767px) {
  .contact-section {
    flex-direction: column;
  }
}
.contact-section .contact-address {
  flex: 1 1;
}
.contact-section .contact-address h4,
.contact-section .contact-address h5 {
  color: #000;
}
.contact-section .contact-address .Contact-details {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding-right: 30px;
}
@media (max-width: 1280px) {
  .contact-section .contact-address .Contact-details {
    flex-direction: column;
    padding-right: 0;
  }
}
.contact-section .contact-address .Contact-details .businessdev1 {
  float: left;
}
.contact-section .contact-address .Contact-details .businessdev1 b {
  color: #333;
}
.contact-section .contact-address .Contact-details .businessdev2 {
  float: right;
}
.contact-section .contact-address .Contact-details .contact-info {
  padding-left: 20px;
}
.contact-section .contact-address .Contact-details .contact-info:first-child {
  padding-left: 0;
}
.contact-section .contact-address .Contact-details .contact-info:last-child {
  padding-right: 0;
  border-right: none;
}
.contact-section .contact-address .Contact-details .contact-info b {
  color: #333;
}
@media (max-width: 1280px) {
  .contact-section .contact-address .Contact-details .contact-info {
    padding: 0 0 20px 0;
    border-right: none;
  }
}
.contact-section .contact-map {
  flex: 1 1;
}
.contact-section .contact-map iframe {
  border: 1px solid #205da8;
}
@media (max-width: 767px) {
  .contact-section .contact-map {
    margin-top: 20px;
  }
}

.acheived-section {
  padding-top: 40px;
  padding-bottom: 40px;
}
@media (max-width: 767px) {
  .acheived-section .row {
    flex-direction: column;
  }
}
.acheived-section .acheived-col {
  border-radius: 20px;
  background: #5aafff;
  background: linear-gradient(to bottom, #5aafff 0%, #1c90ff 100%);
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#5aafff", endColorstr="#1c90ff", GradientType=0);
  text-align: center;
  color: #fff;
  padding: 20px;
}
@media (max-width: 767px) {
  .acheived-section .acheived-col {
    margin-bottom: 20px;
  }
}
.acheived-section .acheived-col img {
  margin-bottom: 10px;
}
.acheived-section .acheived-col h2 {
  font-weight: 500;
  font-family: "fjalla_oneregular", Helvetica, Arial, sans-serif;
  font-size: 42px;
  margin-bottom: 10px;
}
.acheived-section .acheived-col p {
  font-weight: 500;
  font-family: "fjalla_oneregular", Helvetica, Arial, sans-serif;
  font-size: 24px;
  color: #fff;
  margin-bottom: 0;
}

.login-wrapper {
  margin: 100px auto;
}

.login-panel {
  width: 590px;
  background: #fff;
  box-shadow: 0px 0px 25px 2px rgba(0, 0, 0, 0.1);
  padding: 40px 70px;
  margin: auto;
}
@media (max-width: 990px) {
  .login-panel {
    width: 92%;
    padding: 30px;
    text-align: center;
  }
}
.login-panel h2 {
  font-family: "fjalla_oneregular", Helvetica, Arial, sans-serif;
  font-size: 25px;
  color: #000;
  padding: 0px 0px 25px 0px;
  margin: 0;
  text-align: center;
}
.login-panel input[type=text],
.login-panel input[type=email],
.login-panel input[type=password],
.login-panel input[type=number] {
  padding: 12px 15px;
}
.login-panel label {
  font-family: "Open Sans", Helvetica, Arial, sans-serif;
}
.login-panel button {
  background: #0055a6;
  border-radius: 20px;
  font-family: "fjalla_oneregular", Helvetica, Arial, sans-serif;
  font-size: 18px;
  text-transform: uppercase;
  padding: 8px 30px;
}
.login-panel .error {
  border: 1px solid #d90000;
}
.login-panel .invalid-feedback {
  display: block;
}
@media (max-width: 990px) {
  .login-panel .checkbox-col {
    margin-bottom: 10px;
  }
  .login-panel .checkbox-col .form-check-input {
    float: unset;
  }
}

.secondary-title {
  text-align: center;
  margin-bottom: 30px;
}
.secondary-title h2 {
  font-family: "fjalla_oneregular", Helvetica, Arial, sans-serif;
  font-size: 35px;
  color: #000;
  margin-bottom: 20px;
}

.section-title h2 {
  text-align: center;
  font-family: "fjalla_oneregular", Helvetica, Arial, sans-serif;
  font-size: 24px;
  color: #205da8;
  text-transform: uppercase;
  margin-bottom: 20px;
}
.section-title h2 img:first-child {
  margin-right: 15px;
}
.section-title h2 img:last-child {
  margin-left: 15px;
}

.ques-ans {
  padding: 0;
  margin: 0 0 0 30px;
  width: 95%;
}
.ques-ans li h2 {
  font-weight: bold;
  font-size: 14px;
}
.ques-ans li h2 span {
  font-size: 12px;
  font-weight: normal;
}
.ques-ans li p {
  font-size: 14px;
}

.bid-position {
  text-align: center;
  font-size: 20px;
  color: #205da8;
}

.verify-overlay {
  max-width: 1000px;
}
@media (max-width: 1023px) {
  .verify-overlay {
    max-width: 90%;
  }
}

.footer-wrapper {
  background: #f2f5fc;
  padding: 30px 0px;
}
.footer-wrapper .footer-about-comp h2 {
  margin-bottom: 20px;
  text-align: left;
  font-size: 20px;
  color: #363636;
  font-weight: 500;
  font-family: "fjalla_oneregular", Helvetica, Arial, sans-serif;
}
@media (max-width: 767px) {
  .footer-wrapper .footer-about-comp h2 {
    text-align: center;
  }
}
.footer-wrapper .footer-about-comp p {
  margin-bottom: 20px;
}
.footer-wrapper .footer-about-comp .footer-social-icons {
  text-align: left;
}
@media (max-width: 990px) {
  .footer-wrapper .footer-about-comp .footer-social-icons {
    text-align: center;
  }
}
.footer-wrapper .footer-about-comp .footer-social-icons ul {
  margin: 0;
  padding: 0;
  list-style: none;
  display: flex;
  align-items: center;
}
.footer-wrapper .footer-about-comp .footer-social-icons ul li {
  margin-right: 20px;
}
.footer-wrapper .footer-about-comp .footer-social-icons ul li a {
  color: #000;
}
.footer-wrapper .footer-about-comp .footer-social-icons ul li a i.bi {
  font-size: 30px;
}
.footer-wrapper .footer-about-comp .footer-social-icons ul li a:hover {
  color: #205da8;
}
.footer-wrapper .footer-about-comp .footer-social-icons ul li:last-child {
  margin-right: 0;
}
.footer-wrapper .footer-address .address-col {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}
.footer-wrapper .footer-address .address-col:first-child {
  align-items: flex-start;
}
.footer-wrapper .footer-address .address-col:first-child i.bi {
  margin-top: 0px;
}
.footer-wrapper .footer-address .address-col i.bi {
  margin-right: 15px;
  font-size: 22px;
}
.footer-wrapper .footer-address .address-col p {
  line-height: 26px;
  margin-bottom: 0;
}
.footer-wrapper .footer-address .address-col p a {
  color: #565656;
}
.footer-wrapper .footer-form-wrapper input[type=text],
.footer-wrapper .footer-form-wrapper input[type=email] {
  border-radius: 10px;
  padding: 10px;
}
.footer-wrapper .footer-form-wrapper textarea {
  resize: none;
  border-radius: 10px;
  padding: 10px;
}
.footer-wrapper .footer-form-wrapper .col:first-child {
  padding-right: 0;
}
@media (max-width: 990px) {
  .footer-wrapper .footer-form-wrapper .col:first-child {
    padding-right: calc(var(--bs-gutter-x) * 0.5);
  }
}
@media (max-width: 990px) {
  .footer-wrapper .footer-form-wrapper .col {
    flex: unset;
    margin-bottom: 15px;
  }
}
@media (max-width: 990px) {
  .footer-wrapper .footer-form-wrapper .mb-2 {
    margin-bottom: 0 !important;
  }
}
@media (max-width: 990px) {
  .footer-wrapper .footer-form-wrapper .col-12 {
    padding-right: 0;
  }
}
@media (max-width: 990px) {
  .footer-wrapper .footer-form-wrapper .col-12 .col {
    padding-right: 0;
  }
}
@media (max-width: 990px) {
  .footer-wrapper .footer-about-comp,
  .footer-wrapper .footer-address,
  .footer-wrapper .footer-form-wrapper {
    margin-bottom: 50px;
  }
}

.button-style {
  font-family: "fjalla_oneregular", Helvetica, Arial, sans-serif;
  background: #205da8;
  border-radius: 20px;
  font-size: 18px;
  text-transform: uppercase;
  padding: 10px 30px !important;
  color: #fff;
  border: none;
}
.button-style:hover {
  background: #000;
  color: #fff !important;
}

.button-secondary {
  font-family: "fjalla_oneregular", Helvetica, Arial, sans-serif;
  background: #333;
  border-radius: 20px;
  font-size: 18px;
  text-transform: uppercase;
  padding: 10px 30px !important;
  color: #fff;
  border: none;
}
.button-secondary:hover {
  background: #000;
  color: #fff !important;
}

.button-sec-small {
  font-family: "fjalla_oneregular", Helvetica, Arial, sans-serif;
  background: #333;
  border-radius: 20px;
  font-size: 14px;
  text-transform: uppercase;
  padding: 5px 15px !important;
  color: #fff;
  border: none;
}
.button-sec-small:hover {
  background: #000;
  color: #fff !important;
}

.dashboard-wrapper {
  display: flex;
  flex-direction: row;
  width: 90%;
  margin: 200px auto;
}
@media (max-width: 767px) {
  .dashboard-wrapper {
    flex-direction: column;
    margin: 40px auto;
  }
}
.dashboard-wrapper .dash-col {
  box-shadow: 0px 0px 25px 2px rgba(0, 0, 0, 0.1);
  padding: 40px 0px;
  text-align: center;
  justify-content: space-between;
  flex: 1 1;
  margin-right: 30px;
}
@media (max-width: 767px) {
  .dashboard-wrapper .dash-col {
    margin-right: 0;
    margin-bottom: 20px;
    padding: 20px;
  }
}
.dashboard-wrapper .dash-col:last-child {
  margin-right: 0;
}
.dashboard-wrapper .dash-col img {
  max-width: 100%;
  margin-bottom: 20px;
}
.dashboard-wrapper .dash-col h2 {
  font-family: "fjalla_oneregular", Helvetica, Arial, sans-serif;
  font-size: 26px;
  text-transform: uppercase;
  color: #205da8;
  margin: 0;
}

.footer-links {
  height: 50px;
  box-shadow: 0px -10px 10px 0px rgba(202, 202, 202, 0.3);
  -webkit-box-shadow: 0px -10px 10px 0px rgba(202, 202, 202, 0.3);
  -moz-box-shadow: 0px -10px 10px 0px rgba(202, 202, 202, 0.3);
  position: relative;
  z-index: 2;
  background-color: #f9fbff;
  text-align: center;
  display: flex;
  align-items: center;
  font-size: 14px;
  justify-content: center;
}

.summary-container h2 {
  color: "Open Sans", Helvetica, Arial, sans-serif;
  font-size: 30px;
  margin: 0;
  font-weight: bold;
  color: #205da8;
}
.summary-container .title-section {
  display: flex;
  justify-content: space-between;
}
@media (max-width: 767px) {
  .summary-container .title-section {
    flex-direction: column;
  }
  .summary-container .title-section h2,
  .summary-container .title-section input,
  .summary-container .title-section a {
    margin-bottom: 20px;
  }
  .summary-container .title-section input {
    width: 100% !important;
  }
  .summary-container .title-section h2 {
    text-align: center;
  }
  .summary-container .title-section a {
    width: 150px;
    text-align: center;
    margin: auto;
  }
}
.summary-container input[type=text] {
  width: 100% !important;
  font-size: 12px;
}

.action-icons {
  text-align: center;
}
.action-icons .bi {
  margin-right: 5px;
}
.action-icons .bi:last-child {
  margin: 0px;
}
.table-design thead tr td {
  background-color: #ddd;
  font-weight: bold;
  color: #666666;
  font-size: 14px;
  vertical-align: middle;
}
.table-design tbody .rfqstatus_1 {
  background-color: #ebffe5;
}
.table-design tbody .rfqstatus_1:hover {
  background-color: #cffad1;
}
.table-design tbody .rfqstatus_2 {
  background-color: #e5eeff;
}
.table-design tbody .rfqstatus_2:hover {
  background-color: #cfdefa;
}
.table-design tbody .rfqstatus_4 {
  background-color: #ffe5e5;
}
.table-design tbody .rfqstatus_4:hover {
  background-color: #facfcf;
}
.table-design tbody tr td {
  font-size: 14px;
}

.view-prod label {
  font-weight: bold;
  margin-right: 10px;
}

.form-wrapper {
  margin: 50px auto;
  display: block;
  width: 100%;
}
@media (max-width: 990px) {
  .form-wrapper {
    display: block;
  }
}
.form-wrapper .card {
  border: none;
}
.form-wrapper .card .card-header {
  text-transform: uppercase;
  font-weight: bold;
  background-color: #205da8;
  color: white;
}
.form-wrapper .form-headings-wrapper {
  width: 100%;
  border: 1px solid #dddddd;
  z-index: 1;
  position: relative;
  border-bottom: none;
}
@media (max-width: 990px) {
  .form-wrapper .form-headings-wrapper {
    width: 100%;
    float: none;
    margin-bottom: 20px;
  }
}
.form-wrapper .form-headings-wrapper ul {
  padding: 0;
  margin: 0;
  list-style: none;
  display: flex;
  flex-direction: row;
  align-items: center;
}
@media (max-width: 990px) {
  .form-wrapper .form-headings-wrapper ul {
    width: 100%;
    flex-direction: column;
  }
}
.form-wrapper .form-headings-wrapper ul li {
  border-right: 1px solid #fff;
  background: #205da8;
}
@media (max-width: 990px) {
  .form-wrapper .form-headings-wrapper ul li {
    width: 100%;
    border-right: none;
    border-bottom: 1px solid #fff;
  }
}
.form-wrapper .form-headings-wrapper ul li a {
  padding: 20px;
  color: #fff;
  display: block;
  font-family: "fjalla_oneregular", Helvetica, Arial, sans-serif;
  font-size: 16px;
  text-transform: uppercase;
}
.form-wrapper .form-headings-wrapper ul li a:hover, .form-wrapper .form-headings-wrapper ul li a.active {
  background: #fff;
  color: #205da8;
}
.form-wrapper .form-panel-wrapper {
  width: 100%;
  border: 1px solid #dddddd;
  padding: 20px 40px;
  position: relative;
  z-index: 1;
  min-height: 100%;
}
@media (max-width: 990px) {
  .form-wrapper .form-panel-wrapper {
    width: 100%;
    float: none;
    padding: 20px;
  }
  .form-wrapper .form-panel-wrapper .row .col {
    margin-bottom: 1.5rem;
  }
  .form-wrapper .form-panel-wrapper .row .col:last-child {
    margin-bottom: 0;
  }
}
@media (max-width: 767px) {
  .form-wrapper .form-panel-wrapper .form-elements {
    flex-direction: column;
  }
  .form-wrapper .form-panel-wrapper .form-elements .form-column,
  .form-wrapper .form-panel-wrapper .form-elements .plus-icon {
    width: 100%;
  }
}
.form-wrapper .form-panel-wrapper .form-panel .form-column {
  border: 1px solid #ddd;
  padding: 15px;
  align-items: center;
  border-radius: 4px;
  background-color: #fff;
}
.form-wrapper .form-panel-wrapper .form-panel .form-address-panel {
  background-color: #fff;
  margin-top: 0;
}
.form-wrapper .form-panel-wrapper .form-panel .form-address-panel ul,
.form-wrapper .form-panel-wrapper .form-panel .form-address-panel li {
  list-style: none;
}
.form-wrapper .form-panel-wrapper .form-panel:nth-child(even) .form-elements .form-column,
.form-wrapper .form-panel-wrapper .form-panel:nth-child(even) .form-elements .form-address-panel {
  background-color: #f2f5fc;
}
.form-wrapper .form-panel-wrapper .plus-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
.form-wrapper .form-panel-wrapper .plus-icon i.bi {
  font-size: 30px;
  cursor: pointer;
}
.form-wrapper .form-panel-wrapper .approval-panel {
  align-items: center;
}
.form-wrapper .form-panel-wrapper .approval-panel .submit-btn {
  background: #205da8;
  border-radius: 20px;
  font-size: 15px;
  text-transform: uppercase;
  padding: 8px 30px !important;
  color: #fff;
  font-family: "fjalla_oneregular", Helvetica, Arial, sans-serif;
}
.form-wrapper .form-panel-wrapper .approval-panel .submit-btn:hover {
  background: #000;
  color: #fff;
}
.form-wrapper .form-panel-wrapper .approval-panel .alert {
  padding: 8px 20px;
  margin: 0;
}
.form-wrapper .form-panel-wrapper .otp-verify {
  align-items: flex-end;
}
.form-wrapper .form-panel-wrapper .hinttext {
  font-size: 12px;
}
.form-wrapper .form-panel-wrapper .single-col .plus-icon {
  justify-content: flex-end;
}
.form-wrapper .form-panel-wrapper .input-small {
  width: 120px;
}
.form-wrapper .form-panel-wrapper .input-large {
  width: 400px;
}
.form-wrapper .form-panel-wrapper .form-address-panel {
  background: #f2f5fc;
  border-radius: 4px;
  padding: 15px;
  margin-top: 20px;
}
.form-wrapper .form-panel-wrapper .form-address-panel h2 {
  font-family: "Open Sans", Helvetica, Arial, sans-serif;
  font-weight: 500;
  font-size: 20px;
  color: #454545;
  margin-bottom: 20px;
}
@media (max-width: 767px) {
  .form-wrapper .form-panel-wrapper .form-address-panel .empty-col {
    display: none;
  }
}
.form-wrapper .form-panel-wrapper .cta-btn {
  text-align: center;
  width: auto;
}

.sym-icon i.bi {
  font-size: 30px;
  cursor: pointer;
  color: #454545;
}

.email-list {
  padding: 0;
  margin: 0;
  list-style: none;
}
.email-list li {
  display: inline-flex;
  margin-right: 15px;
  align-items: flex-start;
}
.email-list li .bi {
  font-size: 25px;
  cursor: pointer;
  line-height: 0;
}

.inner-content {
  padding: 40px 20px;
}
.inner-content h1 {
  text-align: center;
  font-family: "Open Sans", Helvetica, Arial, sans-serif;
  color: #000;
  font-size: 2.25rem;
  font-weight: 500;
  margin-bottom: 20px;
}
@media (max-width: 767px) {
  .inner-content h1 {
    font-size: 2rem;
  }
}

.faq-wrapper {
  width: 95%;
  margin: auto;
}
@media (max-width: 767px) {
  .faq-wrapper {
    width: 100%;
  }
}
.faq-wrapper .accordion-item h2 button {
  color: #205da8;
  font-weight: bold;
}
.faq-wrapper .accordion-item h2 button:focus {
  outline: none;
  border: none;
  box-shadow: none;
}

.prod-card {
  background: #f0f0f0;
  border: 1px solid #ccc;
  border-radius: 4px;
  padding: 15px;
}
.prod-card h3 {
  font-size: 20px;
  font-weight: bold;
}

.bi-1x {
  font-size: 1em;
}

.bi-1-3x {
  font-size: 1.3em;
}

.bi-1-5x {
  font-size: 1.5em;
}

.bi-2x {
  font-size: 2em;
}

.bi-3x {
  font-size: 3em;
}

.bi-4x {
  font-size: 4em;
}

.bi-5x {
  font-size: 5em;
}

.product-action {
  min-width: 80px;
}

.container {
  max-width: 96%;
}

@media (min-width: 1980px) {
  .container {
    max-width: 1900px;
  }
}
.cursor-pointer {
  cursor: pointer;
}

.tooltip {
  max-width: 500px;
  width: auto;
}

.modal-80 {
  max-width: 80%;
}

.modal-70 {
  max-width: 70%;
}

.error-border {
  border: solid 1px red;
}

.rc-time-picker-input {
  border: none !important;
}

.sno-width {
  min-width: 50px;
  width: 50px;
}

.status-width {
  min-width: 80px;
}

.po-width {
  min-width: 100px;
  width: 100px;
}

.ref-width {
  min-width: 130px;
}

.dates-width {
  min-width: 170px;
}

.subject-width {
  width: 250px;
  min-width: 250px;
  word-break: break-all;
}

.posub-width {
  width: 400px;
  min-width: 400px;
  word-break: break-all;
}

.prno-width {
  min-width: 173px;
}

.subtitle {
  font-weight: bold;
  font-size: 18px;
  padding-left: 0;
  color: #2e2e2e;
  text-transform: uppercase;
  padding-top: 20px;
  padding-bottom: 10px;
}

.pass-strength {
  margin: 10px 0 0 18px;
  list-style: disc;
  padding: 0;
}

.disable-button {
  cursor: default !important;
  color: #ababab !important;
}

.img-right {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
}
.img-right .img-section {
  order: 2;
  margin: 0px 0px 0px 30px;
}
.img-right img {
  border: 5px solid #fff;
  box-shadow: 0px 0px 5px 0px rgb(163, 163, 163);
}
@media (max-width: 768px) {
  .img-right {
    flex-direction: column;
  }
  .img-right .img-section {
    order: initial;
    margin: 0px 0px 30px 0px;
  }
}

.img-left {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
}
.img-left .img-section {
  margin: 0px 30px 0px 0px;
}
.img-left img {
  border: 5px solid #fff;
  box-shadow: 0px 0px 5px 0px rgb(163, 163, 163);
}
@media (max-width: 768px) {
  .img-left {
    flex-direction: column;
  }
  .img-left .img-section {
    order: initial;
    margin: 0px 0px 30px 0px;
  }
}

.left-img {
  display: inline-block;
  width: 100%;
  margin-bottom: 60px;
}
@media (max-width: 768px) {
  .left-img {
    width: 100%;
  }
}
.left-img .content-section {
  float: inherit;
  flex: auto;
}
@media (max-width: 768px) {
  .left-img .content-section {
    width: 100%;
    float: none;
  }
}
.left-img .img-section {
  float: left;
  max-width: 50%;
  padding: 0px 50px 15px 0px;
}
@media (max-width: 768px) {
  .left-img .img-section {
    width: 100%;
    float: none;
    max-width: unset;
    padding: 0px 0px 30px 0px;
  }
}
.left-img .img-section img {
  border: 5px solid #fff;
  box-shadow: 0px 0px 5px 0px rgb(163, 163, 163);
  width: 100%;
}

.right-img {
  display: inline-block;
  width: 100%;
  margin-bottom: 60px;
}
@media (max-width: 768px) {
  .right-img {
    width: 100%;
  }
}
.right-img .content-section {
  float: inherit;
  flex: auto;
}
@media (max-width: 768px) {
  .right-img .content-section {
    width: 100%;
    float: none;
  }
}
.right-img .img-section {
  float: right;
  max-width: 50%;
  padding: 0px 0px 15px 50px;
}
@media (max-width: 768px) {
  .right-img .img-section {
    width: 100%;
    float: none;
    max-width: unset;
    padding: 0px 0px 30px 0px;
  }
}
.right-img .img-section img {
  border: 5px solid #fff;
  box-shadow: 0px 0px 5px 0px rgb(163, 163, 163);
  width: 100%;
}

.content-section {
  flex: 1 1;
}

.img-section {
  flex: 1 1;
}
.img-section img {
  max-width: 100%;
}

.loader {
  width: 70px;
  height: 70px;
  border-radius: 50%;
  display: inline-block;
  border-top: 7px solid #205da8;
  border-right: 7px solid transparent;
  box-sizing: border-box;
  animation: rotation 1s linear infinite;
  position: fixed;
  top: 30%;
  left: 50%;
  z-index: 100;
}
.loader::after {
  content: "";
  box-sizing: border-box;
  position: absolute;
  left: 0;
  top: 0;
  width: 70px;
  height: 70px;
  border-radius: 50%;
  border-bottom: 7px solid #FF3D00;
  border-left: 7px solid transparent;
}
@keyframes rotation {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.permission-table th, .permission-table td {
  padding: 0.3rem 0.5rem;
}

.permission-icon {
  font-size: 20px;
}

.permission-cat {
  background: #e2ecff;
}

.action-disabled {
  opacity: 0.6;
  cursor: not-allowed !important;
}

.card .inai-header {
  text-transform: uppercase;
  font-weight: bold;
  background-color: #205da8;
  color: white;
}

.inai-border-bottom {
  border-bottom: dotted #c1bfbf 1px;
}

.inai-info-background {
  background: rgba(242, 242, 242, 0.73);
  padding: 25px;
  border-radius: 10px !important;
  border: solid 1px #dadada;
}

@media (min-width: 1024px) {
  .inai-border-right {
    border-right: dotted #c1bfbf 1px;
  }
}
.inai-table thead tr td {
  color: #fff;
  line-height: 1.4;
  background-color: #205da8;
  padding-top: 11px;
  padding-bottom: 11px;
}

.page-item.active .page-link {
  z-index: 3;
  color: #fff;
  background-color: #205da8;
  border-color: #205da8;
}

.page-item.disabled .page-link {
  color: #6c757d;
  pointer-events: none;
  background-color: #fff;
  border-color: #dee2e6;
}

.info-combo > h3 {
  margin: 3px 0;
}

.no-margin-bottom {
  margin-bottom: 0 !important;
}

.info-combo > h5 {
  margin: 2px 0 6px 0;
}

/* Messages */
.message-logo {
  float: left;
  background: #2da9e9;
  width: 55px;
  height: 55px;
  margin-right: 5px;
  border-radius: 50%;
  border: 1px solid rgba(0, 0, 0, 0.1);
}

.message-logo label {
  text-align: center;
  width: 100%;
  font-size: 35px;
  color: #fff;
}

.chat-body {
  background-color: #fbfcff;
  margin-top: 10px;
  margin-bottom: 30px;
}

.message {
  position: relative;
  width: 100%;
}

.message br {
  clear: both;
}

.message .message-body {
  position: relative;
  width: auto;
  max-width: calc(100% - 150px);
  float: left;
  background-color: #fff;
  border-radius: 4px;
  border: 1px solid #dbe3e8;
  margin: 0 5px 20px 15px;
  color: #788288;
}

.message:after {
  content: "";
  position: absolute;
  top: 11px;
  left: 63px;
  float: left;
  z-index: 100;
  border-top: 10px solid transparent;
  border-left: none;
  border-bottom: 10px solid transparent;
  border-right: 13px solid #fff;
}

.message:before {
  content: "";
  position: absolute;
  top: 10px;
  left: 62px;
  float: left;
  z-index: 99;
  border-top: 11px solid transparent;
  border-left: none;
  border-bottom: 11px solid transparent;
  border-right: 13px solid #dbe3e8;
}

.message .medium-image {
  float: left;
  margin-left: 10px;
}

.message .message-info {
  width: 100%;
  height: 22px;
}

.message .message-info > h5 > i {
  font-size: 11px;
  font-weight: 700;
  margin: 0 2px 0 0;
  color: #a2b8c5;
}

.message .message-info > h5 {
  color: #a2b8c5;
  margin: 8px 0 0 60px;
  font-size: 12px;
  float: right;
  padding-right: 10px;
}

.message .message-info > h4 {
  font-size: 14px;
  font-weight: 600;
  margin: 7px 13px 0 10px;
  color: #65addd;
  float: left;
}

.message hr {
  margin: 4px 2%;
  width: 96%;
  opacity: 0.75;
}

.message .message-text {
  text-align: left;
  padding: 3px 13px 10px 13px;
  font-size: 14px;
  color: #fff;
}

.message.my-message .message-body {
  float: right;
  margin: 0 15px 20px 5px;
}

.message.my-message:after {
  content: "";
  position: absolute;
  top: 11px;
  left: auto;
  right: 63px;
  float: left;
  z-index: 100;
  border-top: 10px solid transparent;
  border-left: 13px solid #fff;
  border-bottom: 10px solid transparent;
  border-right: none;
}

.message.my-message:before {
  content: "";
  position: absolute;
  top: 10px;
  left: auto;
  right: 62px;
  float: left;
  z-index: 99;
  border-top: 11px solid transparent;
  border-left: 13px solid #dbe3e8;
  border-bottom: 11px solid transparent;
  border-right: none;
}

.message.my-message .message-info > h5 {
  float: left;
  padding-left: 10px;
  padding-right: 0;
}

.message.my-message .message-info > h4 {
  float: right;
}

.message.info .message-body {
  background-color: #2da9e9;
  border: 1px solid #2da9e9;
  color: #fff;
}

.message.info:after, .message.info:before {
  border-right: 13px solid #2da9e9;
}

.message.success .message-body {
  background-color: #0ec8a2;
  border: 1px solid #0ec8a2;
  color: #fff;
}

.message.success:after, .message.success:before {
  border-right: 13px solid #0ec8a2;
}

.message.warning .message-body {
  background-color: #ff9e2a;
  border: 1px solid #ff9e2a;
  color: #fff;
}

.message.warning:after, .message.warning:before {
  border-right: 13px solid #ff9e2a;
}

.message.danger .message-body {
  background-color: #f95858;
  border: 1px solid #f95858;
  color: #fff;
}

.message.danger:after, .message.danger:before {
  border-right: 13px solid #f95858;
}

.message.dark .message-body {
  background-color: #314557;
  border: 1px solid #314557;
  color: #fff;
}

.message.dark:after, .message.dark:before {
  border-right: 13px solid #314557;
}

.message.info .message-info > h4, .message.success .message-info > h4,
.message.warning .message-info > h4, .message.danger .message-info > h4,
.message.dark .message-info > h4 {
  color: #fff;
}

.message.info .message-info > h5, .message.info .message-info > h5 > i,
.message.success .message-info > h5, .message.success .message-info > h5 > i,
.message.warning .message-info > h5, .message.warning .message-info > h5 > i,
.message.danger .message-info > h5, .message.danger .message-info > h5 > i,
.message.dark .message-info > h5, .message.dark .message-info > h5 > i {
  color: #fff;
  opacity: 0.9;
}

.chat-body .reply {
  margin-left: 80px;
}

.chat-body .reply .message-text {
  color: #788288;
}

.chat-body .reply .chat-body {
  background-color: white;
}

.chat-body .reply .message-info {
  color: #000;
}

.chat-body .reply .message-info > h4 {
  color: #65addd;
}

.chat-body .reply .message-logo {
  background: #ffa500;
}

.reply-box {
  max-width: 700px;
}

.reply-box textarea {
  border: none;
  width: 100%;
  height: 40px;
}

.reply-box .message-body {
  width: 100%;
}

.reply-box button {
  float: left;
}

.react-datepicker-wrapper {
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/styles/scss/styles.scss"],"names":[],"mappings":"AAAA;EACI,UAAA;EACA,SAAA;AACJ;;AAEA;EACI,gCAAA;EACA,oHAAA;EAEA,mBAAA;EACA,kBAAA;AAAJ;AAaA;;EAEI,YAAA;EACA,UAAA;EACA,SAAA;EACA,sBAAA;EACA,sDAhBW;EAiBX,cAAA;AAXJ;;AAcA;EACI,sBAAA;AAXJ;;AAcA;;EAEI,sDA1BW;EA2BX,cAAA;AAXJ;;AAcA;EACI,qBAAA;EACA,cAAA;AAXJ;;AAcA;EACI,eAAA;AAXJ;;AAmBA;;;;EAKI,aAAA;EACA,qBAAA;AAjBJ;AAmBI;;;;EACI,gBAAA;EACA,aAAA;AAdR;;AAkBA;;EAEI,wBAAA;EACA,SAAA;AAfJ;;AAmBI;EACI,gBAAA;EACA,aAAA;AAhBR;;AAoBA;EACI,YAAA;AAjBJ;AAmBI;EACI,gBAAA;EACA,aAAA;AAjBR;;AAqBA;EACI,WAAA;AAlBJ;;AAqBA;EACI,YAAA;EACA,qDAAA;EACA,6DAAA;EACA,0DAAA;EACA,kBAAA;EACA,UAAA;EACA,yBAAA;AAlBJ;AAoBI;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,YAAA;AAlBR;AAoBQ;EACI,aAAA;EACA,mBAAA;EACA,YAAA;AAlBZ;AAoBY;EACI,UAAA;EACA,SAAA;EACA,gBAAA;AAlBhB;AAoBgB;EACI,oBAAA;EACA,mBAAA;EACA,kBAAA;AAlBpB;AAoBoB;EALJ;IAMQ,kBAAA;EAjBtB;AACF;AAmBoB;EACI,cAAA;AAjBxB;AAoB4B;EADJ;IAEQ,aAAA;EAjB9B;AACF;AAqBoB;EACI,kBAAA;AAnBxB;AAyBQ;EACI,aAAA;EACA,YAAA;AAvBZ;AAyBY;EACI,UAAA;EACA,SAAA;EACA,gBAAA;AAvBhB;AAyBgB;EACI,oBAAA;EACA,mBAAA;EACA,kBAAA;EACA,YAAA;AAvBpB;AAyBoB;EANJ;IAOQ,kBAAA;EAtBtB;AACF;AAwBoB;EACI,eAAA;AAtBxB;AAyBoB;EACI,cAAA;AAvBxB;AAyBwB;EACI,eAAA;EACA,WAAA;AAvB5B;AAyB4B;EACI,cA9JlB;AAuId;;AAiCA;EACI,gBAAA;EACA,WAAA;EACA,gBAAA;EACA,MAAA;EACA,YAAA;EACA,gCAAA;AA9BJ;;AAiCA;EACI,mBAAA;EACA,WAAA;AA9BJ;AAgCI;EArJA,aAAA;EACA,mBAAA;AAwHJ;AA+BQ;EAHJ;IAIQ,sBAAA;EA5BV;AACF;AA8BQ;EACI,UAAA;AA5BZ;AA8BY;EAHJ;IAIQ,UAAA;EA3Bd;AACF;AA6BY;EAPJ;IAQQ,WAAA;IACA,kBAAA;IACA,QAAA;IACA,iBAAA;EA1Bd;AACF;AA4BY;EACI,8DA/MH;EAgNG,eAAA;EACA,iBAAA;EACA,WAAA;EACA,mBAAA;AA1BhB;AA4BgB;EAPJ;IAQQ,eAAA;IACA,iBAAA;IACA,mBAAA;EAzBlB;AACF;AA4BY;EACI,mBAAA;AA1BhB;AA+BQ;EACI,UAAA;AA7BZ;AA+BY;EAHJ;IAIQ,UAAA;EA5Bd;AACF;AA8BY;EAPJ;IAQQ,WAAA;IACA,kBAAA;EA3Bd;AACF;AA6BY;EACI,eAAA;AA3BhB;;AAkCI;EADJ;IAEQ,yCAAA;EA9BN;AACF;AAgCI;EACI,YAAA;EACA,UAAA;EACA,WAAA;AA9BR;AAgCQ;EACI,aAAA;EACA,YAAA;EACA,gBAAA;AA9BZ;;AAmCA;EACI,aAAA;EACA,mBAAA;EACA,gBAAA;AAhCJ;AAkCI;EALJ;IAMQ,sBAAA;IACA,uBAAA;IACA,sBAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,UAAA;IACA,UAAA;EA/BN;AACF;AAiCI;EAhBJ;IAiBQ,gBAAA;EA9BN;AACF;AAgCI;EACI,kBAAA;AA9BR;AAgCQ;EAHJ;IAIQ,kBAAA;EA7BV;AACF;AA+BQ;EAPJ;IAQQ,kBAAA;EA5BV;AACF;AA8BQ;EAXJ;IAYQ,kBAAA;EA3BV;AACF;AA6BQ;EAfJ;IAgBQ,eAAA;IACA,mBAAA;EA1BV;AACF;AA4BQ;EACI,eAAA;AA1BZ;AA6BQ;EACI,UAAA;EACA,8DArTC;EAsTD,yBAAA;EACA,eAAA;EACA,cApTE;AAyRd;AA6BY;EAPJ;IAQQ,eAAA;EA1Bd;AACF;AA4BY;EAXJ;IAYQ,eAAA;EAzBd;AACF;AA2BY;EAEI,WAAA;AA1BhB;AA6BY;EACI,mBApUF;EAqUE,mBAAA;EACA,eAAA;EACA,yBAAA;EACA,4BAAA;EACA,WAAA;AA3BhB;AA6BgB;EACI,gBAAA;EACA,WAAA;AA3BpB;AAgCQ;EACI,8DAvVC;EAwVD,eAAA;EACA,cAAA;EACA,yBAAA;EACA,qBAAA;EAvTR,aAAA;EACA,mBAAA;AA0RJ;AA+BY;EACI,cAAA;EACA,gBAAA;AA7BhB;AAgCY;EACI,WAAA;EACA,YAAA;EACA,mBAAA;EACA,yBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,iBAAA;EACA,eAAA;AA9BhB;AAgCgB;EACI,gBAAA;EACA,eAAA;AA9BpB;AAmCgB;EACI,iBAAA;EACA,iBAAA;EACA,eAAA;AAjCpB;AAmCoB;EACI,sDAhYT;EAiYS,eAAA;EACA,WAAA;EACA,oBAAA;AAjCxB;;AAyCA;EACI,iBAAA;AAtCJ;AAwCI;EACI,cAvYM;EAwYN,eAAA;EACA,wBAAA;EACA,8DA9YK;EA+YL,qBAAA;AAtCR;AAwCQ;EAPJ;IAQQ,eAAA;EArCV;AACF;AAwCI;EACI,iBAAA;AAtCR;AA0CQ;EACI,UAAA;AAxCZ;AA2CQ;EALJ;IAMQ,kBAAA;IACA,mBAAA;EAxCV;AACF;AA2CI;EACI,iBAAA;AAzCR;AA2CQ;EACI,cAraE;AA4Xd;AA6CI;EACI,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,WAAA;AA3CR;AA+CQ;EACI,iBAAA;AA7CZ;AAgDQ;EACI,UAAA;EACA,kBAAA;EACA,gBAAA;AA9CZ;AAgDY;EACI,oBAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;AA9ChB;AAgDgB;EACI,iBAAA;AA9CpB;;AAqDA;EACI,mBAAA;EACA,yBAAA;AAlDJ;AAoDI;EACI,kBAAA;AAlDR;AAoDQ;EAHJ;IAIQ,UAAA;EAjDV;AACF;AAoDI;EApbA,aAAA;EACA,mBAAA;EAqbI,eAAA;AAjDR;AAmDQ;EAJJ;IAKQ,UAAA;IACA,gBAAA;EAhDV;AACF;AAkDQ;EATJ;IAUQ,iBAAA;EA/CV;AACF;AAiDQ;EACI,UAAA;EACA,oBAAA;EACA,mBAAA;AA/CZ;AAiDY;EACI,mBAAA;AA/ChB;AAkDY;EACI,cA3eF;EA4eE,eAAA;EACA,8DAjfH;EAkfG,mBAAA;EACA,mBAAA;AAhDhB;AAmDY;EACI,eAAA;EACA,sDA5fD;EA6fC,iBAAA;EACA,mBAAA;AAjDhB;AAoDY;EACI,cA1fF;EA2fE,eAAA;EACA,yBAAA;EACA,gCAAA;AAlDhB;AAoDgB;EACI,mBAAA;AAlDpB;;AAyDA;EACI,kBAAA;EACA,iBAAA;AAtDJ;AAwDI;EACI,eAAA;AAtDR;;AA0DA;EACI,aAAA;EACA,mBAAA;EACA,WAAA;EACA,gBAAA;AAvDJ;AAyDI;EANJ;IAOQ,sBAAA;EAtDN;AACF;AAwDI;EACI,SAAA;AAtDR;AAwDQ;;EAEI,WAAA;AAtDZ;AAyDQ;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;AAvDZ;AAyDY;EANJ;IAOQ,sBAAA;IACA,gBAAA;EAtDd;AACF;AAwDY;EACI,WAAA;AAtDhB;AAuDgB;EACI,WAAA;AArDpB;AAwDY;EACI,YAAA;AAtDhB;AAyDY;EACI,kBAAA;AAvDhB;AAyDgB;EACI,eAAA;AAvDpB;AA0DgB;EACI,gBAAA;EACA,kBAAA;AAxDpB;AA2DgB;EACI,WAAA;AAzDpB;AA4DgB;EAhBJ;IAiBQ,mBAAA;IACA,kBAAA;EAzDlB;AACF;AA8DI;EACI,SAAA;AA5DR;AA8DQ;EACI,yBAAA;AA5DZ;AA+DQ;EAPJ;IAQQ,gBAAA;EA5DV;AACF;;AAgEA;EACI,iBAAA;EACA,oBAAA;AA7DJ;AAgEQ;EADJ;IAEQ,sBAAA;EA7DV;AACF;AAgEI;EACI,mBAAA;EACA,mBAAA;EAGA,gEAAA;EACA,kHAAA;EACA,kBAAA;EACA,WAAA;EACA,aAAA;AA9DR;AAgEQ;EAXJ;IAYQ,mBAAA;EA7DV;AACF;AA+DQ;EACI,mBAAA;AA7DZ;AAgEQ;EACI,gBAAA;EACA,8DA/nBC;EAgoBD,eAAA;EACA,mBAAA;AA9DZ;AAiEQ;EACI,gBAAA;EACA,8DAtoBC;EAuoBD,eAAA;EACA,WAAA;EACA,gBAAA;AA/DZ;;AAoEA;EACI,kBAAA;AAjEJ;;AAoEA;EACI,YAAA;EACA,gBAAA;EACA,+CAAA;EACA,kBAAA;EACA,YAAA;AAjEJ;AAmEI;EAPJ;IAQQ,UAAA;IACA,aAAA;IACA,kBAAA;EAhEN;AACF;AAkEI;EACI,8DAhqBK;EAiqBL,eAAA;EACA,WAAA;EACA,yBAAA;EACA,SAAA;EACA,kBAAA;AAhER;AAmEI;;;;EAII,kBAAA;AAjER;AAoEI;EACI,sDAprBO;AAknBf;AAqEI;EACI,mBAAA;EACA,mBAAA;EACA,8DAtrBK;EAurBL,eAAA;EACA,yBAAA;EACA,iBAAA;AAnER;AAsEI;EACI,yBAAA;AApER;AAuEI;EACI,cAAA;AArER;AAyEQ;EADJ;IAEQ,mBAAA;EAtEV;EAwEU;IACI,YAAA;EAtEd;AACF;;AA2EA;EACI,kBAAA;EACA,mBAAA;AAxEJ;AA0EI;EACI,8DAptBK;EAqtBL,eAAA;EACA,WAAA;EACA,mBAAA;AAxER;;AA6EI;EACI,kBAAA;EACA,8DA9tBK;EA+tBL,eAAA;EACA,cA5tBM;EA6tBN,yBAAA;EACA,mBAAA;AA1ER;AA4EQ;EACI,kBAAA;AA1EZ;AA6EQ;EACI,iBAAA;AA3EZ;;AAgFA;EACI,UAAA;EACA,kBAAA;EACA,UAAA;AA7EJ;AAgFQ;EACI,iBAAA;EACA,eAAA;AA9EZ;AAgFY;EACI,eAAA;EACA,mBAAA;AA9EhB;AAkFQ;EACI,eAAA;AAhFZ;;AAqFA;EACI,kBAAA;EACA,eAAA;EACA,cAnwBU;AAirBd;;AAqFA;EACI,iBAAA;AAlFJ;AAoFI;EAHJ;IAIQ,cAAA;EAjFN;AACF;;AAoFA;EACI,mBAAA;EACA,iBAAA;AAjFJ;AAoFQ;EACI,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;EACA,8DA7xBC;AA2sBb;AAoFY;EARJ;IASQ,kBAAA;EAjFd;AACF;AAoFQ;EACI,mBAAA;AAlFZ;AAqFQ;EACI,gBAAA;AAnFZ;AAqFY;EAHJ;IAIQ,kBAAA;EAlFd;AACF;AAoFY;EACI,SAAA;EACA,UAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;AAlFhB;AAoFgB;EACI,kBAAA;AAlFpB;AAoFoB;EACI,WAAA;AAlFxB;AAoFwB;EACI,eAAA;AAlF5B;AAqFwB;EACI,cA7zBd;AA0uBd;AAuFoB;EACI,eAAA;AArFxB;AA6FQ;EACI,aAAA;EACA,mBAAA;EACA,mBAAA;AA3FZ;AA6FY;EACI,uBAAA;AA3FhB;AA6FgB;EACI,eAAA;AA3FpB;AA+FY;EACI,kBAAA;EACA,eAAA;AA7FhB;AAgGY;EACI,iBAAA;EACA,gBAAA;AA9FhB;AAgGgB;EACI,cAAA;AA9FpB;AAsGQ;;EAEI,mBAAA;EACA,aAAA;AApGZ;AAuGQ;EACI,YAAA;EACA,mBAAA;EACA,aAAA;AArGZ;AAwGQ;EACI,gBAAA;AAtGZ;AAwGY;EAHJ;IAIQ,6CAAA;EArGd;AACF;AAyGY;EADJ;IAEQ,WAAA;IACA,mBAAA;EAtGd;AACF;AA0GY;EADJ;IAEQ,2BAAA;EAvGd;AACF;AA2GY;EADJ;IAEQ,gBAAA;EAxGd;AACF;AA2GgB;EADJ;IAEQ,gBAAA;EAxGlB;AACF;AAgHQ;EAHJ;;;IAIQ,mBAAA;EA3GV;AACF;;AA+GA;EACI,8DAr6BS;EAs6BT,mBAl6BU;EAm6BV,mBAAA;EACA,eAAA;EACA,yBAAA;EACA,6BAAA;EACA,WAAA;EACA,YAAA;AA5GJ;AA8GI;EACI,gBAAA;EACA,sBAAA;AA5GR;;AAgHA;EACI,8DAr7BS;EAs7BT,gBAAA;EACA,mBAAA;EACA,eAAA;EACA,yBAAA;EACA,6BAAA;EACA,WAAA;EACA,YAAA;AA7GJ;AA+GI;EACI,gBAAA;EACA,sBAAA;AA7GR;;AAiHA;EACI,8DAr8BS;EAs8BT,gBAAA;EACA,mBAAA;EACA,eAAA;EACA,yBAAA;EACA,4BAAA;EACA,WAAA;EACA,YAAA;AA9GJ;AAgHI;EACI,gBAAA;EACA,sBAAA;AA9GR;;AAkHA;EACI,aAAA;EACA,mBAAA;EACA,UAAA;EACA,kBAAA;AA/GJ;AAiHI;EANJ;IAOQ,sBAAA;IACA,iBAAA;EA9GN;AACF;AAgHI;EACI,+CAAA;EACA,iBAAA;EACA,kBAAA;EACA,8BAAA;EACA,SAAA;EACA,kBAAA;AA9GR;AAgHQ;EARJ;IASQ,eAAA;IACA,mBAAA;IACA,aAAA;EA7GV;AACF;AA+GQ;EACI,eAAA;AA7GZ;AAgHQ;EACI,eAAA;EACA,mBAAA;AA9GZ;AAiHQ;EACI,8DAv/BC;EAw/BD,eAAA;EACA,yBAAA;EACA,cAt/BE;EAu/BF,SAAA;AA/GZ;;AAoHA;EACI,YAAA;EACA,uDAAA;EACA,+DAAA;EACA,4DAAA;EACA,kBAAA;EACA,UAAA;EACA,yBAAA;EACA,kBAAA;EAp+BA,aAAA;EACA,mBAAA;EAq+BA,eAAA;EACA,uBAAA;AAhHJ;;AAoHI;EACI,gDAphCO;EAqhCP,eAAA;EACA,SAAA;EACA,iBAAA;EACA,cAhhCM;AA+5Bd;AAoHI;EACI,aAAA;EACA,8BAAA;AAlHR;AAoHQ;EAJJ;IAKQ,sBAAA;EAjHV;EAmHU;;;IAGI,mBAAA;EAjHd;EAoHU;IACI,sBAAA;EAlHd;EAqHU;IACI,kBAAA;EAnHd;EAsHU;IACI,YAAA;IACA,kBAAA;IACA,YAAA;EApHd;AACF;AA0HI;EACI,sBAAA;EACA,eAAA;AAxHR;;AA4HA;EACI,kBAAA;AAzHJ;AA2HI;EAGI,iBAAA;AA3HR;AA6HQ;EACI,WAAA;AA3HZ;AAsIQ;EACI,sBAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;EACA,sBAAA;AApIZ;AAyIQ;EACI,yBAAA;AAvIZ;AAyIY;EACI,yBAAA;AAvIhB;AA2IQ;EACI,yBAAA;AAzIZ;AA2IY;EACI,yBAAA;AAzIhB;AA6IQ;EACI,yBAAA;AA3IZ;AA6IY;EACI,yBAAA;AA3IhB;AAgJY;EACI,eAAA;AA9IhB;;AAoJI;EACI,iBAAA;EACA,kBAAA;AAjJR;;AAqJA;EACI,iBAAA;EACA,cAAA;EACA,WAAA;AAlJJ;AAoJI;EALJ;IAMQ,cAAA;EAjJN;AACF;AAkJI;EACI,YAAA;AAhJR;AAiJQ;EACI,yBAAA;EACA,iBAAA;EACA,yBAAA;EACA,YAAA;AA/IZ;AAoJI;EACI,WAAA;EAGA,yBAAA;EACA,UAAA;EACA,kBAAA;EAGA,mBAAA;AAtJR;AAwJQ;EAXJ;IAYQ,WAAA;IACA,WAAA;IACA,mBAAA;EArJV;AACF;AAwJQ;EACI,UAAA;EACA,SAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;AAtJZ;AA0JY;EAVJ;IAWQ,WAAA;IACA,sBAAA;EAvJd;AACF;AAyJY;EACI,4BAAA;EACA,mBAlrCF;AA2hCd;AAyJgB;EAJJ;IAKQ,WAAA;IACA,kBAAA;IACA,6BAAA;EAtJlB;AACF;AAgKgB;EACI,aAAA;EACA,WAAA;EACA,cAAA;EACA,8DA1sCP;EA2sCO,eAAA;EACA,yBAAA;AA9JpB;AAgKoB;EAEI,gBAAA;EACA,cA7sCV;AA8iCd;AAsKI;EACI,WAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,UAAA;EACA,gBAAA;AApKR;AAsKQ;EARJ;IASQ,WAAA;IACA,WAAA;IACA,aAAA;EAnKV;EAqKU;IACI,qBAAA;EAnKd;EAqKc;IACI,gBAAA;EAnKlB;AACF;AAwKY;EADJ;IAEQ,sBAAA;EArKd;EAuKc;;IAEI,WAAA;EArKlB;AACF;AA4KY;EACI,sBAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,sBAAA;AA1KhB;AA6KY;EACI,sBAAA;EACA,aAAA;AA3KhB;AA6KgB;;EAEI,gBAAA;AA3KpB;AAkLoB;;EAEI,yBAAA;AAhLxB;AAsLQ;EArvCJ,aAAA;EACA,mBAAA;EAsvCQ,uBAAA;EACA,sBAAA;AAnLZ;AAyLY;EACI,eAAA;EACA,eAAA;AAvLhB;AA2LQ;EACI,mBAAA;AAzLZ;AA2LY;EACI,mBAxyCF;EAyyCE,mBAAA;EACA,eAAA;EACA,yBAAA;EACA,4BAAA;EACA,WAAA;EACA,8DAlzCH;AAynCb;AA2LgB;EACI,gBAAA;EACA,WAAA;AAzLpB;AA6LY;EACI,iBAAA;EACA,SAAA;AA3LhB;AA+LQ;EACI,qBAAA;AA7LZ;AAgMQ;EACI,eAAA;AA9LZ;AAkMY;EACI,yBAAA;AAhMhB;AAoMQ;EACI,YAAA;AAlMZ;AAqMQ;EACI,YAAA;AAnMZ;AAsMQ;EACI,mBAAA;EACA,kBAAA;EACA,aAAA;EACA,gBAAA;AApMZ;AAsMY;EACI,sDAj2CD;EAk2CC,gBAAA;EACA,eAAA;EACA,cAAA;EACA,mBAAA;AApMhB;AA0MgB;EAHJ;IAIQ,aAAA;EAvMlB;AACF;AA2MQ;EACI,kBAAA;EACA,WAAA;AAzMZ;;AA+MI;EACI,eAAA;EACA,eAAA;EACA,cAAA;AA5MR;;AAgNA;EACI,UAAA;EACA,SAAA;EACA,gBAAA;AA7MJ;AA+MI;EACI,oBAAA;EACA,kBAAA;EACA,uBAAA;AA7MR;AA+MQ;EACI,eAAA;EACA,eAAA;EACA,cAAA;AA7MZ;;AAkNA;EACI,kBAAA;AA/MJ;AAiNI;EACI,kBAAA;EACA,sDAv5CO;EAw5CP,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AA/MR;AAiNQ;EARJ;IASQ,eAAA;EA9MV;AACF;;AAkNA;EACI,UAAA;EACA,YAAA;AA/MJ;AAiNI;EAJJ;IAKQ,WAAA;EA9MN;AACF;AAiNQ;EACI,cAr6CE;EAs6CF,iBAAA;AA/MZ;AAiNY;EACI,aAAA;EACA,YAAA;EACA,gBAAA;AA/MhB;;AAqNA;EACI,mBAAA;EACA,sBAAA;EACA,kBAAA;EACA,aAAA;AAlNJ;AAoNI;EACI,eAAA;EACA,iBAAA;AAlNR;;AAsNA;EACI,cAAA;AAnNJ;;AAsNA;EACI,gBAAA;AAnNJ;;AAsNA;EACI,gBAAA;AAnNJ;;AAsNA;EACI,cAAA;AAnNJ;;AAsNA;EACI,cAAA;AAnNJ;;AAsNA;EACI,cAAA;AAnNJ;;AAsNA;EACI,cAAA;AAnNJ;;AAsNA;EACI,eAAA;AAnNJ;;AAsNA;EACI,cAAA;AAnNJ;;AAsNA;EACI;IACI,iBAAA;EAnNN;AACF;AAsNA;EACI,eAAA;AApNJ;;AAuNA;EACI,gBAAA;EACA,WAAA;AApNJ;;AAuNA;EACI,cAAA;AApNJ;;AAuNA;EACI,cAAA;AApNJ;;AAwNA;EACI,qBAAA;AArNJ;;AAwNA;EACI,uBAAA;AArNJ;;AAwNA;EACI,eAAA;EACA,WAAA;AArNJ;;AAwNA;EACI,eAAA;AArNJ;;AAwNA;EACI,gBAAA;EACA,YAAA;AArNJ;;AAuNA;EACI,gBAAA;AApNJ;;AAuNA;EACI,gBAAA;AApNJ;;AAuNA;EACI,YAAA;EACA,gBAAA;EACA,qBAAA;AApNJ;;AAsNA;EACI,YAAA;EACA,gBAAA;EACA,qBAAA;AAnNJ;;AAqNA;EACI,gBAAA;AAlNJ;;AAqNA;EACI,iBAAA;EACA,eAAA;EACA,eAAA;EACA,cAAA;EACA,yBAAA;EACA,iBAAA;EACA,oBAAA;AAlNJ;;AAuNA;EACI,qBAAA;EACA,gBAAA;EACA,UAAA;AApNJ;;AAuNA;EACI,0BAAA;EACA,yBAAA;AApNJ;;AAuNA;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;AApNJ;AAsNI;EACI,QAAA;EACA,wBAAA;AApNR;AAuNI;EACI,sBAAA;EACA,8CAAA;AArNR;AAwNI;EAfJ;IAgBQ,sBAAA;EArNN;EAuNM;IACI,cAAA;IACA,wBAAA;EArNV;AACF;;AAyNA;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;AAtNJ;AAwNI;EACI,wBAAA;AAtNR;AAyNI;EACI,sBAAA;EACA,8CAAA;AAvNR;AA0NI;EAdJ;IAeQ,sBAAA;EAvNN;EAyNM;IACI,cAAA;IACA,wBAAA;EAvNV;AACF;;AA2NA;EACI,qBAAA;EACA,WAAA;EACA,mBAAA;AAxNJ;AA0NI;EALJ;IAMQ,WAAA;EAvNN;AACF;AAyNI;EACI,cAAA;EACA,UAAA;AAvNR;AAyNQ;EAJJ;IAKQ,WAAA;IACA,WAAA;EAtNV;AACF;AAyNI;EACI,WAAA;EACA,cAAA;EACA,0BAAA;AAvNR;AAyNQ;EALJ;IAMQ,WAAA;IACA,WAAA;IACA,gBAAA;IACA,yBAAA;EAtNV;AACF;AAwNQ;EACI,sBAAA;EACA,8CAAA;EACA,WAAA;AAtNZ;;AA2NA;EACI,qBAAA;EACA,WAAA;EACA,mBAAA;AAxNJ;AA0NI;EALJ;IAMQ,WAAA;EAvNN;AACF;AAyNI;EACI,cAAA;EACA,UAAA;AAvNR;AAyNQ;EAJJ;IAKQ,WAAA;IACA,WAAA;EAtNV;AACF;AAyNI;EACI,YAAA;EACA,cAAA;EACA,0BAAA;AAvNR;AAyNQ;EALJ;IAMQ,WAAA;IACA,WAAA;IACA,gBAAA;IACA,yBAAA;EAtNV;AACF;AAwNQ;EACI,sBAAA;EACA,8CAAA;EACA,WAAA;AAtNZ;;AA2NA;EACI,SAAA;AAxNJ;;AA2NA;EACI,SAAA;AAxNJ;AA0NI;EACI,eAAA;AAxNR;;AA4NA;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,qBAAA;EACA,6BAAA;EACA,mCAAA;EACA,sBAAA;EACA,sCAAA;EACA,eAAA;EACA,QAAA;EACA,SAAA;EACA,YAAA;AAzNJ;AA2NE;EACE,WAAA;EACA,sBAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gCAAA;EACA,kCAAA;AAzNJ;AA4NE;EACE;IACE,uBAAA;EA1NJ;EA4NE;IACE,yBAAA;EA1NJ;AACF;;AA+NI;EACI,sBAAA;AA5NR;;AAgOA;EACI,eAAA;AA7NJ;;AAgOA;EACI,mBAAA;AA7NJ;;AAgOA;EACI,YAAA;EACA,8BAAA;AA7NJ;;AAgOI;EACI,yBAAA;EACA,iBAAA;EACA,yBAAA;EACA,YAAA;AA7NR;;AAkOA;EACI,iCAAA;AA/NJ;;AAiOA;EACI,qCAAA;EACA,aAAA;EACA,8BAAA;EACA,yBAAA;AA9NJ;;AAgOA;EACI;IACI,gCAAA;EA7NN;AACF;AAkOI;EACA,WAAA;EACA,gBAAA;EACA,yBAAA;EACA,iBAAA;EACA,oBAAA;AAhOJ;;AAoOA;EACI,UAAA;EACA,WAAA;EACA,yBAAA;EACA,qBAAA;AAjOJ;;AAmOA;EACI,cAAA;EACA,oBAAA;EACA,sBAAA;EACA,qBAAA;AAhOJ;;AAsOA;EACI,aAAA;AAnOJ;;AAsOA;EACI,2BAAA;AAnOJ;;AAsOA;EACI,mBAAA;AAnOJ;;AAuOA,aAAA;AAEA;EACI,WAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,oCAAA;AArOJ;;AAwOA;EACI,kBAAA;EACA,WAAA;EACA,eAAA;EACA,WAAA;AArOJ;;AAwOA;EACE,yBAAA;EACA,gBAAA;EACA,mBAAA;AArOF;;AAwOA;EACE,kBAAA;EACA,WAAA;AArOF;;AAwOA;EACE,WAAA;AArOF;;AAwOA;EACE,kBAAA;EACA,WAAA;EACA,6BAAA;EACA,WAAA;EACA,sBAAA;EACA,kBAAA;EACA,yBAAA;EACA,uBAAA;EACA,cAAA;AArOF;;AAwOA;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,kCAAA;EACA,iBAAA;EACA,qCAAA;EACA,6BAAA;AArOF;;AAwOA;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,WAAA;EACA,kCAAA;EACA,iBAAA;EACA,qCAAA;EACA,gCAAA;AArOF;;AAwOA;EACE,WAAA;EACA,iBAAA;AArOF;;AAwOA;EACE,WAAA;EACA,YAAA;AArOF;;AAwOA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;AArOF;;AAwOA;EACE,cAAA;EACA,oBAAA;EACA,eAAA;EACA,YAAA;EACA,mBAAA;AArOF;;AAwOA;EACE,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,cAAA;EACA,WAAA;AArOF;;AAwOA;EACE,cAAA;EACA,UAAA;EACA,aAAA;AArOF;;AAwOA;EACE,gBAAA;EACA,2BAAA;EACA,eAAA;EACA,WAAA;AArOF;;AAwOA;EACE,YAAA;EACA,uBAAA;AArOF;;AAwOA;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,kCAAA;EACA,4BAAA;EACA,qCAAA;EACA,kBAAA;AArOF;;AAwOA;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,WAAA;EACA,WAAA;EACA,kCAAA;EACA,+BAAA;EACA,qCAAA;EACA,kBAAA;AArOF;;AAwOA;EACE,WAAA;EACA,kBAAA;EACA,gBAAA;AArOF;;AAwOA;EACE,YAAA;AArOF;;AAwOA;EACE,yBAAA;EACA,yBAAA;EACA,WAAA;AArOF;;AAwOA;EACE,gCAAA;AArOF;;AAwOA;EACE,yBAAA;EACA,yBAAA;EACA,WAAA;AArOF;;AAwOA;EACE,gCAAA;AArOF;;AAwOA;EACE,yBAAA;EACA,yBAAA;EACA,WAAA;AArOF;;AAwOA;EACE,gCAAA;AArOF;;AAwOA;EACE,yBAAA;EACA,yBAAA;EACA,WAAA;AArOF;;AAwOA;EACE,gCAAA;AArOF;;AAwOA;EACE,yBAAA;EACA,yBAAA;EACA,WAAA;AArOF;;AAwOA;EACE,gCAAA;AArOF;;AAwOA;;;EAGE,WAAA;AArOF;;AAwOA;;;;;EAKE,WAAA;EACA,YAAA;AArOF;;AAwOA;EACI,iBAAA;AArOJ;;AAwOA;EACG,cAAA;AArOH;;AAuOA;EACK,uBAAA;AApOL;;AAsOA;EACK,WAAA;AAnOL;;AAqOA;EACK,cAAA;AAlOL;;AAqOA;EACK,mBAAA;AAlOL;;AAqOC;EACG,gBAAA;AAlOJ;;AAqOA;EACI,YAAA;EACA,WAAA;EACA,YAAA;AAlOJ;;AAqOC;EACG,WAAA;AAlOJ;;AAqOC;EACG,WAAA;AAlOJ;;AAqOC;EACG,WAAA;AAlOJ","sourcesContent":["* {\n    padding: 0;\n    margin: 0;\n}\n\n@font-face {\n    font-family: 'fjalla_oneregular';\n    src: url('../fonts/fjallaone-regular-webfont.woff2') format('woff2'),\n        url('../fonts/fjallaone-regular-webfont.woff') format('woff');\n    font-weight: normal;\n    font-style: normal;\n}\n\n$OpenSansFont: 'Open Sans',\n    Helvetica,\n    Arial,\n    sans-serif;\n$FjallaFont: 'fjalla_oneregular',\n    Helvetica,\n    Arial,\n    sans-serif;\n$PrimaryBlue: #205da8;\n\nhtml,\nbody {\n    height: 100%;\n    padding: 0;\n    margin: 0;\n    background-color: #fff;\n    font-family: $OpenSansFont;\n    color: #565656;\n}\n\ndiv {\n    box-sizing: border-box;\n}\n\ndiv,\np {\n    font-family: $OpenSansFont;\n    color: #6f6f6f;\n}\n\na {\n    text-decoration: none;\n    color: #1f75de;\n}\n\nimg {\n    max-width: 100%;\n}\n\n@mixin flex-default {\n    display: flex;\n    align-items: center;\n}\n\ninput[type='text'],\ninput[type='email'],\ninput[type='password'],\ninput[type='number'] {\n    // padding: 12px 15px;\n    outline: none;\n    appearance: textfield;\n\n    &:focus {\n        box-shadow: none;\n        outline: none;\n    }\n}\n\ninput::-webkit-outer-spin-button,\ninput::-webkit-inner-spin-button {\n    -webkit-appearance: none;\n    margin: 0;\n}\n\ninput[type='checkbox'] {\n    &:focus {\n        box-shadow: none;\n        outline: none;\n    }\n}\n\ntextarea {\n    resize: none;\n\n    &:focus {\n        box-shadow: none;\n        outline: none;\n    }\n}\n\n.main-wrapper {\n    width: 100%;\n}\n\n.social-links {\n    height: 50px;\n    box-shadow: 0px 5px 10px 0px rgba(202, 202, 202, 0.30);\n    -webkit-box-shadow: 0px 5px 10px 0px rgba(202, 202, 202, 0.30);\n    -moz-box-shadow: 0px 5px 10px 0px rgba(202, 202, 202, 0.30);\n    position: relative;\n    z-index: 2;\n    background-color: #f9fbff;\n\n    .container {\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n        height: 100%;\n\n        .links-left {\n            display: flex;\n            align-items: center;\n            height: 100%;\n\n            ul {\n                padding: 0;\n                margin: 0;\n                list-style: none;\n\n                li {\n                    display: inline-flex;\n                    align-items: center;\n                    margin-right: 30px;\n\n                    @media (max-width: 767px) {\n                        margin-right: 10px;\n                    }\n\n                    a {\n                        color: #565656;\n\n                        span {\n                            @media (max-width: 767px) {\n                                display: none;\n                            }\n                        }\n                    }\n\n                    i.bi {\n                        margin-right: 10px;\n                    }\n                }\n            }\n        }\n\n        .links-right {\n            display: flex;\n            height: 100%;\n\n            ul {\n                padding: 0;\n                margin: 0;\n                list-style: none;\n\n                li {\n                    display: inline-flex;\n                    align-items: center;\n                    margin-right: 25px;\n                    height: 100%;\n\n                    @media (max-width: 767px) {\n                        margin-right: 10px;\n                    }\n\n                    &:last-child {\n                        margin-right: 0;\n                    }\n\n                    a {\n                        color: #565656;\n\n                        i.bi {\n                            font-size: 22px;\n                            color: #000;\n\n                            &:hover {\n                                color: $PrimaryBlue;\n                            }\n                        }\n                    }\n                }\n            }\n        }\n    }\n}\n\n.sticky-navbar {\n    background: #fff;\n    width: 100%;\n    position: sticky;\n    top: 0;\n    z-index: 100;\n    border-bottom: 1px solid #e3e3e3;\n}\n\n.banner-wrapper {\n    background: #f2f5fc;\n    width: 100%;\n\n    .banner-panel {\n        @include flex-default();\n\n        @media (max-width: 990px) {\n            flex-direction: column;\n        }\n\n        .banner-left {\n            width: 41%;\n\n            @media (min-width: 1024px) and (max-width: 1200px) {\n                width: 50%;\n            }\n\n            @media (max-width: 990px) {\n                width: 100%;\n                text-align: center;\n                order: 2;\n                margin: 40px auto;\n            }\n\n            h2 {\n                font-family: $FjallaFont;\n                font-size: 45px;\n                line-height: 65px;\n                color: #000;\n                margin-bottom: 20px;\n\n                @media (min-width: 990px) and (max-width: 1200px) {\n                    font-size: 35px;\n                    line-height: 50px;\n                    margin-bottom: 10px;\n                }\n            }\n\n            p {\n                margin-bottom: 30px;\n            }\n\n        }\n\n        .banner-right {\n            width: 60%;\n\n            @media (min-width: 1024px) and (max-width: 1200px) {\n                width: 50%;\n            }\n\n            @media (max-width: 990px) {\n                width: 100%;\n                text-align: center;\n            }\n\n            img {\n                max-width: 100%;\n            }\n        }\n    }\n}\n\n.logo-menu {\n    @media (max-width: 767px) {\n        justify-content: space-between !important;\n    }\n\n    .navbar-toggler {\n        border: none;\n        padding: 0;\n        width: 50px;\n\n        &:focus {\n            outline: none;\n            border: none;\n            box-shadow: none;\n        }\n    }\n}\n\n.menubar {\n    display: flex;\n    align-items: center;\n    flex-grow: unset;\n\n    @media (max-width: 767px) {\n        flex-direction: column;\n        align-items: flex-start;\n        background-color: #fff;\n        padding: 15px;\n        border: 1px solid #ccc;\n        position: fixed;\n        width: 94%;\n        top: 128px;\n    }\n\n    @media (min-width: 768px) and (max-width: 990px) {\n        margin-top: 30px;\n    }\n\n    li {\n        margin-right: 50px;\n\n        @media (max-width: 1200px) {\n            margin-right: 15px;\n        }\n\n        @media (min-width: 1200px) and (max-width: 1366px) {\n            margin-right: 25px;\n        }\n\n        @media (min-width: 768px) and (max-width: 990px) {\n            margin-right: 10px;\n        }\n\n        @media (max-width: 767px) {\n            margin-right: 0;\n            margin-bottom: 20px;\n        }\n\n        &:last-child {\n            margin-right: 0;\n        }\n\n        a {\n            padding: 0;\n            font-family: $FjallaFont;\n            text-transform: uppercase;\n            font-size: 18px;\n            color: $PrimaryBlue;\n\n            @media (max-width: 1200px) {\n                font-size: 13px;\n            }\n\n            @media (min-width: 768px) and (max-width: 990px) {\n                font-size: 11px;\n            }\n\n            &:hover,\n            &.active {\n                color: #000;\n            }\n\n            &.login-link {\n                background: $PrimaryBlue;\n                border-radius: 20px;\n                font-size: 18px;\n                text-transform: uppercase;\n                padding: 8px 30px !important;\n                color: #fff;\n\n                &:hover {\n                    background: #000;\n                    color: #fff;\n                }\n            }\n        }\n\n        &.profile-link {\n            font-family: $FjallaFont;\n            font-size: 16px;\n            color: #2e2e2e;\n            text-transform: uppercase;\n            letter-spacing: 0.5px;\n            @include flex-default();\n\n            span {\n                color: #808080;\n                margin-left: 5px;\n            }\n\n            .profile-icon {\n                width: 48px;\n                height: 48px;\n                border-radius: 100%;\n                border: 1px solid #d6d6d6;\n                display: inline-flex;\n                align-items: center;\n                justify-content: center;\n                background: #fff;\n                margin-left: 10px;\n                cursor: pointer;\n\n                img {\n                    max-height: 40px;\n                    max-width: 40px;\n                }\n            }\n\n            .dropdown-menu {\n                li {\n                    text-align: right;\n                    padding: 5px 10px;\n                    margin-right: 0;\n\n                    a {\n                        font-family: $OpenSansFont;\n                        font-size: 14px;\n                        color: #000;\n                        text-transform: none;\n                    }\n                }\n            }\n        }\n    }\n}\n\n.about-section {\n    padding: 40px 0px;\n\n    h3 {\n        color: $PrimaryBlue;\n        font-size: 22px;\n        margin: 0px 0px 20px 0px;\n        font-family: $FjallaFont;\n        letter-spacing: 0.5px;\n\n        @media (max-width: 767px) {\n            font-size: 16px;\n        }\n    }\n\n    p {\n        line-height: 28px;\n    }\n\n    .home-about-img {\n        img {\n            width: 95%;\n        }\n\n        @media (max-width: 990px) {\n            text-align: center;\n            margin-bottom: 30px;\n        }\n    }\n\n    .read-more {\n        text-align: right;\n\n        a {\n            color: $PrimaryBlue;\n        }\n    }\n\n    .highlight-text {\n        text-align: center;\n        font-size: 18px;\n        font-style: italic;\n        color: #000;\n    }\n\n    .home-about-cont {\n        p {\n            line-height: 28px;\n        }\n\n        ul {\n            padding: 0;\n            margin: 0 0 0 15px;\n            list-style: none;\n\n            li {\n                padding-bottom: 10px;\n                line-height: 26px;\n                display: flex;\n                align-items: center;\n\n                svg {\n                    margin-right: 5px;\n                }\n            }\n        }\n    }\n}\n\n.services-section {\n    background: #f2f5fc;\n    padding: 40px 0px 0px 0px;\n\n    .service-img {\n        text-align: center;\n\n        @media (min-width: 1440px) {\n            width: 40%;\n        }\n    }\n\n    .home-service-cont {\n        @include flex-default();\n        flex-wrap: wrap;\n\n        @media (min-width: 1440px) {\n            width: 60%;\n            padding-left: 5%;\n        }\n\n        @media (max-width: 990px) {\n            margin: 30px auto;\n        }\n\n        .service-col {\n            width: 50%;\n            padding-bottom: 20px;\n            padding-right: 20px;\n\n            img {\n                margin-bottom: 10px;\n            }\n\n            h2 {\n                color: $PrimaryBlue;\n                font-size: 20px;\n                font-family: $FjallaFont;\n                margin-bottom: 15px;\n                margin-bottom: 10px;\n            }\n\n            p {\n                font-size: 14px;\n                font-family: $OpenSansFont;\n                line-height: 24px;\n                margin-bottom: 10px;\n            }\n\n            a {\n                color: $PrimaryBlue;\n                font-size: 12px;\n                text-transform: uppercase;\n                border-bottom: 1px solid $PrimaryBlue;\n\n                &:hover {\n                    border-bottom: none;\n                }\n            }\n        }\n    }\n}\n\n.service-img {\n    text-align: center;\n    margin: 40px auto;\n\n    img {\n        max-width: 100%;\n    }\n}\n\n.contact-section {\n    display: flex;\n    flex-direction: row;\n    width: 100%;\n    margin-top: 30px;\n\n    @media (max-width: 767px) {\n        flex-direction: column;\n    }\n\n    .contact-address {\n        flex: 1;\n\n        h4,\n        h5 {\n            color: #000;\n        }\n\n        .Contact-details {\n            display: flex;\n            flex-direction: row;\n            justify-content: space-between;\n            padding-right: 30px;\n\n            @media (max-width: 1280px) {\n                flex-direction: column;\n                padding-right: 0;\n            }\n\n            .businessdev1{\n                float: left;\n                b {\n                    color: #333;\n                }\n            }\n            .businessdev2{\n                float: right;\n            }\n\n            .contact-info {\n                padding-left: 20px;\n\n                &:first-child {\n                    padding-left: 0;\n                }\n\n                &:last-child {\n                    padding-right: 0;\n                    border-right: none;\n                }\n\n                b {\n                    color: #333;\n                }\n\n                @media (max-width: 1280px) {\n                    padding: 0 0 20px 0;\n                    border-right: none;\n                }\n            }\n        }\n    }\n\n    .contact-map {\n        flex: 1;\n\n        iframe {\n            border: 1px solid $PrimaryBlue;\n        }\n\n        @media (max-width: 767px) {\n            margin-top: 20px;\n        }\n    }\n}\n\n.acheived-section {\n    padding-top: 40px;\n    padding-bottom: 40px;\n\n    .row {\n        @media (max-width: 767px) {\n            flex-direction: column;\n        }\n    }\n\n    .acheived-col {\n        border-radius: 20px;\n        background: #5aafff;\n        background: -moz-linear-gradient(top, #5aafff 0%, #1c90ff 100%);\n        background: -webkit-linear-gradient(top, #5aafff 0%, #1c90ff 100%);\n        background: linear-gradient(to bottom, #5aafff 0%, #1c90ff 100%);\n        filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#5aafff', endColorstr='#1c90ff', GradientType=0);\n        text-align: center;\n        color: #fff;\n        padding: 20px;\n\n        @media (max-width: 767px) {\n            margin-bottom: 20px;\n        }\n\n        img {\n            margin-bottom: 10px;\n        }\n\n        h2 {\n            font-weight: 500;\n            font-family: $FjallaFont;\n            font-size: 42px;\n            margin-bottom: 10px;\n        }\n\n        p {\n            font-weight: 500;\n            font-family: $FjallaFont;\n            font-size: 24px;\n            color: #fff;\n            margin-bottom: 0;\n        }\n    }\n}\n\n.login-wrapper {\n    margin: 100px auto;\n}\n\n.login-panel {\n    width: 590px;\n    background: #fff;\n    box-shadow: 0px 0px 25px 2px rgba(0, 0, 0, 0.10);\n    padding: 40px 70px;\n    margin: auto;\n\n    @media (max-width: 990px) {\n        width: 92%;\n        padding: 30px;\n        text-align: center;\n    }\n\n    h2 {\n        font-family: $FjallaFont;\n        font-size: 25px;\n        color: #000;\n        padding: 0px 0px 25px 0px;\n        margin: 0;\n        text-align: center;\n    }\n\n    input[type='text'],\n    input[type='email'],\n    input[type='password'],\n    input[type='number'] {\n        padding: 12px 15px;\n    }\n\n    label {\n        font-family: $OpenSansFont;\n    }\n\n    button {\n        background: #0055a6;\n        border-radius: 20px;\n        font-family: $FjallaFont;\n        font-size: 18px;\n        text-transform: uppercase;\n        padding: 8px 30px;\n    }\n\n    .error {\n        border: 1px solid #d90000;\n    }\n\n    .invalid-feedback {\n        display: block;\n    }\n\n    .checkbox-col {\n        @media (max-width: 990px) {\n            margin-bottom: 10px;\n\n            .form-check-input {\n                float: unset;\n            }\n        }\n    }\n}\n\n.secondary-title {\n    text-align: center;\n    margin-bottom: 30px;\n\n    h2 {\n        font-family: $FjallaFont;\n        font-size: 35px;\n        color: #000;\n        margin-bottom: 20px;\n    }\n}\n\n.section-title {\n    h2 {\n        text-align: center;\n        font-family: $FjallaFont;\n        font-size: 24px;\n        color: $PrimaryBlue;\n        text-transform: uppercase;\n        margin-bottom: 20px;\n\n        img:first-child {\n            margin-right: 15px;\n        }\n\n        img:last-child {\n            margin-left: 15px;\n        }\n    }\n}\n\n.ques-ans {\n    padding: 0;\n    margin: 0 0 0 30px;\n    width: 95%;\n\n    li {\n        h2 {\n            font-weight: bold;\n            font-size: 14px;\n\n            span {\n                font-size: 12px;\n                font-weight: normal;\n            }\n        }\n\n        p {\n            font-size: 14px;\n        }\n    }\n}\n\n.bid-position {\n    text-align: center;\n    font-size: 20px;\n    color: $PrimaryBlue;\n}\n\n.verify-overlay {\n    max-width: 1000px;\n\n    @media (max-width: 1023px) {\n        max-width: 90%;\n    }\n}\n\n.footer-wrapper {\n    background: #f2f5fc;\n    padding: 30px 0px;\n\n    .footer-about-comp {\n        h2 {\n            margin-bottom: 20px;\n            text-align: left;\n            font-size: 20px;\n            color: #363636;\n            font-weight: 500;\n            font-family: $FjallaFont;\n\n            @media (max-width: 767px) {\n                text-align: center;\n            }\n        }\n\n        p {\n            margin-bottom: 20px;\n        }\n\n        .footer-social-icons {\n            text-align: left;\n\n            @media (max-width: 990px) {\n                text-align: center;\n            }\n\n            ul {\n                margin: 0;\n                padding: 0;\n                list-style: none;\n                display: flex;\n                align-items: center;\n\n                li {\n                    margin-right: 20px;\n\n                    a {\n                        color: #000;\n\n                        i.bi {\n                            font-size: 30px;\n                        }\n\n                        &:hover {\n                            color: $PrimaryBlue;\n                        }\n                    }\n\n                    &:last-child {\n                        margin-right: 0;\n                    }\n                }\n            }\n        }\n    }\n\n    .footer-address {\n        .address-col {\n            display: flex;\n            align-items: center;\n            margin-bottom: 10px;\n\n            &:first-child {\n                align-items: flex-start;\n\n                i.bi {\n                    margin-top: 0px;\n                }\n            }\n\n            i.bi {\n                margin-right: 15px;\n                font-size: 22px;\n            }\n\n            p {\n                line-height: 26px;\n                margin-bottom: 0;\n\n                a {\n                    color: #565656;\n                }\n            }\n        }\n    }\n\n    .footer-form-wrapper {\n\n        input[type='text'],\n        input[type='email'] {\n            border-radius: 10px;\n            padding: 10px;\n        }\n\n        textarea {\n            resize: none;\n            border-radius: 10px;\n            padding: 10px;\n        }\n\n        .col:first-child {\n            padding-right: 0;\n\n            @media (max-width: 990px) {\n                padding-right: calc(var(--bs-gutter-x) * .5);\n            }\n        }\n\n        .col {\n            @media (max-width: 990px) {\n                flex: unset;\n                margin-bottom: 15px;\n            }\n        }\n\n        .mb-2 {\n            @media (max-width: 990px) {\n                margin-bottom: 0 !important;\n            }\n        }\n\n        .col-12 {\n            @media (max-width: 990px) {\n                padding-right: 0;\n            }\n\n            .col {\n                @media (max-width: 990px) {\n                    padding-right: 0;\n                }\n            }\n        }\n    }\n\n    .footer-about-comp,\n    .footer-address,\n    .footer-form-wrapper {\n        @media (max-width: 990px) {\n            margin-bottom: 50px;\n        }\n    }\n}\n\n.button-style {\n    font-family: $FjallaFont;\n    background: $PrimaryBlue;\n    border-radius: 20px;\n    font-size: 18px;\n    text-transform: uppercase;\n    padding: 10px 30px !important;\n    color: #fff;\n    border: none;\n\n    &:hover {\n        background: #000;\n        color: #fff !important;\n    }\n}\n\n.button-secondary {\n    font-family: $FjallaFont;\n    background: #333;\n    border-radius: 20px;\n    font-size: 18px;\n    text-transform: uppercase;\n    padding: 10px 30px !important;\n    color: #fff;\n    border: none;\n\n    &:hover {\n        background: #000;\n        color: #fff !important;\n    }\n}\n\n.button-sec-small {\n    font-family: $FjallaFont;\n    background: #333;\n    border-radius: 20px;\n    font-size: 14px;\n    text-transform: uppercase;\n    padding: 5px 15px !important;\n    color: #fff;\n    border: none;\n\n    &:hover {\n        background: #000;\n        color: #fff !important;\n    }\n}\n\n.dashboard-wrapper {\n    display: flex;\n    flex-direction: row;\n    width: 90%;\n    margin: 200px auto;\n\n    @media (max-width: 767px) {\n        flex-direction: column;\n        margin: 40px auto;\n    }\n\n    .dash-col {\n        box-shadow: 0px 0px 25px 2px rgba(0, 0, 0, 0.10);\n        padding: 40px 0px;\n        text-align: center;\n        justify-content: space-between;\n        flex: 1;\n        margin-right: 30px;\n\n        @media (max-width: 767px) {\n            margin-right: 0;\n            margin-bottom: 20px;\n            padding: 20px;\n        }\n\n        &:last-child {\n            margin-right: 0;\n        }\n\n        img {\n            max-width: 100%;\n            margin-bottom: 20px;\n        }\n\n        h2 {\n            font-family: $FjallaFont;\n            font-size: 26px;\n            text-transform: uppercase;\n            color: $PrimaryBlue;\n            margin: 0;\n        }\n    }\n}\n\n.footer-links {\n    height: 50px;\n    box-shadow: 0px -10px 10px 0px rgba(202, 202, 202, 0.30);\n    -webkit-box-shadow: 0px -10px 10px 0px rgba(202, 202, 202, 0.30);\n    -moz-box-shadow: 0px -10px 10px 0px rgba(202, 202, 202, 0.30);\n    position: relative;\n    z-index: 2;\n    background-color: #f9fbff;\n    text-align: center;\n    @include flex-default();\n    font-size: 14px;\n    justify-content: center;\n}\n\n.summary-container {\n    h2 {\n        color: $OpenSansFont;\n        font-size: 30px;\n        margin: 0;\n        font-weight: bold;\n        color: $PrimaryBlue;\n    }\n\n    .title-section {\n        display: flex;\n        justify-content: space-between;\n\n        @media (max-width: 767px) {\n            flex-direction: column;\n\n            h2,\n            input,\n            a {\n                margin-bottom: 20px;\n            }\n\n            input {\n                width: 100% !important;\n            }\n\n            h2 {\n                text-align: center;\n            }\n\n            a {\n                width: 150px;\n                text-align: center;\n                margin: auto;\n            }\n\n\n        }\n    }\n\n    input[type='text'] {\n        width: 100% !important;\n        font-size: 12px;\n    }\n}\n\n.action-icons {\n    text-align: center;\n\n    .bi {\n        //font-size: 20px;\n        //cursor: pointer;\n        margin-right: 5px;\n\n        &:last-child {\n            margin: 0px;\n        }\n    }\n\n    a {\n        //color: #000;\n    }\n}\n\n.table-design {\n    thead {\n        tr td {\n            background-color: #ddd;\n            font-weight: bold;\n            color: #666666;\n            font-size: 14px;\n            vertical-align: middle;\n        }\n    }\n\n    tbody {\n        .rfqstatus_1 {\n            background-color: #ebffe5;\n\n            &:hover {\n                background-color: #cffad1;\n            }\n        }\n\n        .rfqstatus_2 {\n            background-color: #e5eeff;\n\n            &:hover {\n                background-color: #cfdefa;\n            }\n        }\n\n        .rfqstatus_4 {\n            background-color: #ffe5e5;\n\n            &:hover {\n                background-color: #facfcf;\n            }\n        }\n\n        tr {\n            td {\n                font-size: 14px;\n            }\n        }\n    }\n}\n.view-prod {\n    label {\n        font-weight: bold;\n        margin-right: 10px;\n    }\n}\n\n.form-wrapper {\n    margin: 50px auto;\n    display: block;\n    width: 100%;\n\n    @media (max-width: 990px) {\n        display: block;\n    }\n    .card {\n        border:none;\n        .card-header{\n            text-transform: uppercase;\n            font-weight: bold;\n            background-color: #205da8;\n            color: white;\n        }\n    }\n    \n        \n    .form-headings-wrapper {\n        width: 100%;\n        // border-top-left-radius: 20px;\n        // border-bottom-left-radius: 20px;\n        border: 1px solid #dddddd;\n        z-index: 1;\n        position: relative;\n        // border-top-right-radius: 20px;\n        // border-bottom-right-radius: 20px;\n        border-bottom: none;\n\n        @media (max-width: 990px) {\n            width: 100%;\n            float: none;\n            margin-bottom: 20px;\n        }\n\n\n        ul {\n            padding: 0;\n            margin: 0;\n            list-style: none;\n            display: flex;\n            flex-direction: row;\n            align-items: center;\n\n            // border-top-left-radius: 20px;\n            // border-top-right-radius: 20px;\n            @media (max-width: 990px) {\n                width: 100%;\n                flex-direction: column;\n            }\n\n            li {\n                border-right: 1px solid #fff;\n                background: $PrimaryBlue;\n\n                @media (max-width: 990px) {\n                    width: 100%;\n                    border-right: none;\n                    border-bottom: 1px solid #fff;\n                }\n\n                &:first-child a {\n                    // border-top-left-radius: 20px;\n                }\n\n                &:last-child a {\n                    // border-top-right-radius: 20px;\n                }\n\n                a {\n                    padding: 20px;\n                    color: #fff;\n                    display: block;\n                    font-family: $FjallaFont;\n                    font-size: 16px;\n                    text-transform: uppercase;\n\n                    &:hover,\n                    &.active {\n                        background: #fff;\n                        color: $PrimaryBlue;\n                    }\n                }\n            }\n        }\n    }\n\n    .form-panel-wrapper {\n        width: 100%;\n        border: 1px solid #dddddd;\n        padding: 20px 40px;\n        position: relative;\n        z-index: 1;\n        min-height: 100%;\n\n        @media (max-width: 990px) {\n            width: 100%;\n            float: none;\n            padding: 20px;\n\n            .row .col {\n                margin-bottom: 1.5rem;\n\n                &:last-child {\n                    margin-bottom: 0;\n                }\n            }\n        }\n\n        .form-elements {\n            @media (max-width: 767px) {\n                flex-direction: column;\n\n                .form-column,\n                .plus-icon {\n                    width: 100%;\n                }\n            }\n        }\n\n\n\n        .form-panel {\n            .form-column {\n                border: 1px solid #ddd;\n                padding: 15px;\n                align-items: center;\n                border-radius: 4px;\n                background-color: #fff;\n            }\n\n            .form-address-panel {\n                background-color: #fff;\n                margin-top: 0;\n\n                ul,\n                li {\n                    list-style: none;\n                }\n            }\n\n            &:nth-child(even) {\n                .form-elements {\n\n                    .form-column,\n                    .form-address-panel {\n                        background-color: #f2f5fc;\n                    }\n                }\n            }\n        }\n\n        .plus-icon {\n            @include flex-default();\n            justify-content: center;\n            flex-direction: column;\n\n            @media (max-width: 767px) {\n                // margin-top: 30px;\n            }\n\n            i.bi {\n                font-size: 30px;\n                cursor: pointer;\n            }\n        }\n\n        .approval-panel {\n            align-items: center;\n\n            .submit-btn {\n                background: $PrimaryBlue;\n                border-radius: 20px;\n                font-size: 15px;\n                text-transform: uppercase;\n                padding: 8px 30px !important;\n                color: #fff;\n                font-family: $FjallaFont;\n\n                &:hover {\n                    background: #000;\n                    color: #fff;\n                }\n            }\n\n            .alert {\n                padding: 8px 20px;\n                margin: 0;\n            }\n        }\n\n        .otp-verify {\n            align-items: flex-end;\n        }\n\n        .hinttext {\n            font-size: 12px;\n        }\n\n        .single-col {\n            .plus-icon {\n                justify-content: flex-end;\n            }\n        }\n\n        .input-small {\n            width: 120px;\n        }\n\n        .input-large {\n            width: 400px;\n        }\n\n        .form-address-panel {\n            background: #f2f5fc;\n            border-radius: 4px;\n            padding: 15px;\n            margin-top: 20px;\n\n            h2 {\n                font-family: $OpenSansFont;\n                font-weight: 500;\n                font-size: 20px;\n                color: #454545;\n                margin-bottom: 20px;\n            }\n\n            .empty-col {\n\n                // border: 1px solid red;\n                @media (max-width: 767px) {\n                    display: none;\n                }\n            }\n        }\n\n        .cta-btn {\n            text-align: center;\n            width: auto;\n        }\n    }\n}\n\n.sym-icon {\n    i.bi {\n        font-size: 30px;\n        cursor: pointer;\n        color: #454545;\n    }\n}\n\n.email-list {\n    padding: 0;\n    margin: 0;\n    list-style: none;\n\n    li {\n        display: inline-flex;\n        margin-right: 15px;\n        align-items: flex-start;\n\n        .bi {\n            font-size: 25px;\n            cursor: pointer;\n            line-height: 0;\n        }\n    }\n}\n\n.inner-content {\n    padding: 40px 20px;\n\n    h1 {\n        text-align: center;\n        font-family: $OpenSansFont;\n        color: #000;\n        font-size: 2.25rem;\n        font-weight: 500;\n        margin-bottom: 20px;\n\n        @media (max-width: 767px) {\n            font-size: 2rem;\n        }\n    }\n}\n\n.faq-wrapper {\n    width: 95%;\n    margin: auto;\n\n    @media (max-width: 767px) {\n        width: 100%;\n    }\n\n    .accordion-item {\n        h2 button {\n            color: $PrimaryBlue;\n            font-weight: bold;\n\n            &:focus {\n                outline: none;\n                border: none;\n                box-shadow: none;\n            }\n        }\n    }\n}\n\n.prod-card {\n    background: #f0f0f0;\n    border: 1px solid #ccc;\n    border-radius: 4px;\n    padding: 15px;\n\n    h3 {\n        font-size: 20px;\n        font-weight: bold;\n    }\n}\n\n.bi-1x {\n    font-size: 1em;\n}\n\n.bi-1-3x {\n    font-size: 1.3em;\n}\n\n.bi-1-5x {\n    font-size: 1.5em;\n}\n\n.bi-2x {\n    font-size: 2em;\n}\n\n.bi-3x {\n    font-size: 3em;\n}\n\n.bi-4x {\n    font-size: 4em;\n}\n\n.bi-5x {\n    font-size: 5em;\n}\n\n.product-action {\n    min-width: 80px;\n}\n\n.container {\n    max-width: 96%;\n}\n\n@media (min-width: 1980px) {\n    .container {\n        max-width: 1900px;\n    }\n}\n\n.cursor-pointer {\n    cursor: pointer;\n}\n\n.tooltip {\n    max-width: 500px;\n    width: auto;\n}\n\n.modal-80 {\n    max-width: 80%;\n}\n\n.modal-70 {\n    max-width: 70%;\n}\n\n\n.error-border {\n    border: solid 1px red;\n}\n\n.rc-time-picker-input {\n    border: none !important;\n}\n\n.sno-width {\n    min-width: 50px;\n    width: 50px;\n}\n\n.status-width {\n    min-width: 80px;\n    ;\n}\n.po-width {\n    min-width: 100px;\n    width: 100px;\n}\n.ref-width {\n    min-width: 130px;\n}\n\n.dates-width {\n    min-width: 170px;\n}\n\n.subject-width {\n    width: 250px;\n    min-width: 250px;\n    word-break: break-all;\n}\n.posub-width {\n    width: 400px;\n    min-width: 400px;\n    word-break: break-all;\n}\n.prno-width {\n    min-width: 173px;\n}\n\n.subtitle {\n    font-weight: bold;\n    font-size: 18px;\n    padding-left: 0;\n    color: #2e2e2e;\n    text-transform: uppercase;\n    padding-top: 20px;\n    padding-bottom: 10px;\n\n}\n\n\n.pass-strength {\n    margin: 10px 0 0 18px;\n    list-style: disc;\n    padding: 0;\n}\n\n.disable-button {\n    cursor: default !important;\n    color: #ababab !important;\n}\n\n.img-right {\n    display: flex;\n    flex-direction: row;\n    align-items: flex-start;\n\n    .img-section {\n        order: 2;\n        margin: 0px 0px 0px 30px;\n    }\n\n    img {\n        border: 5px solid #fff;\n        box-shadow: 0px 0px 5px 0px rgba(163, 163, 163, 1);\n    }\n\n    @media (max-width: 768px) {\n        flex-direction: column;\n\n        .img-section {\n            order: initial;\n            margin: 0px 0px 30px 0px;\n        }\n    }\n}\n\n.img-left {\n    display: flex;\n    flex-direction: row;\n    align-items: flex-start;\n\n    .img-section {\n        margin: 0px 30px 0px 0px;\n    }\n\n    img {\n        border: 5px solid #fff;\n        box-shadow: 0px 0px 5px 0px rgba(163, 163, 163, 1);\n    }\n\n    @media (max-width: 768px) {\n        flex-direction: column;\n\n        .img-section {\n            order: initial;\n            margin: 0px 0px 30px 0px;\n        }\n    }\n}\n\n.left-img {\n    display: inline-block;\n    width: 100%;\n    margin-bottom: 60px;\n\n    @media (max-width: 768px) {\n        width: 100%;\n    }\n\n    .content-section {\n        float: inherit;\n        flex: auto;\n\n        @media (max-width: 768px) {\n            width: 100%;\n            float: none;\n        }\n    }\n\n    .img-section {\n        float: left;\n        max-width: 50%;\n        padding: 0px 50px 15px 0px;\n\n        @media (max-width: 768px) {\n            width: 100%;\n            float: none;\n            max-width: unset;\n            padding: 0px 0px 30px 0px;\n        }\n\n        img {\n            border: 5px solid #fff;\n            box-shadow: 0px 0px 5px 0px rgba(163, 163, 163, 1);\n            width: 100%;\n        }\n    }\n}\n\n.right-img {\n    display: inline-block;\n    width: 100%;\n    margin-bottom: 60px;\n\n    @media (max-width: 768px) {\n        width: 100%;\n    }\n\n    .content-section {\n        float: inherit;\n        flex: auto;\n\n        @media (max-width: 768px) {\n            width: 100%;\n            float: none;\n        }\n    }\n\n    .img-section {\n        float: right;\n        max-width: 50%;\n        padding: 0px 0px 15px 50px;\n\n        @media (max-width: 768px) {\n            width: 100%;\n            float: none;\n            max-width: unset;\n            padding: 0px 0px 30px 0px;\n        }\n\n        img {\n            border: 5px solid #fff;\n            box-shadow: 0px 0px 5px 0px rgba(163, 163, 163, 1);\n            width: 100%;\n        }\n    }\n}\n\n.content-section {\n    flex: 1;\n}\n\n.img-section {\n    flex: 1;\n\n    img {\n        max-width: 100%;\n    }\n}\n\n.loader {\n    width: 70px;\n    height: 70px;\n    border-radius: 50%;\n    display: inline-block;\n    border-top: 7px solid #205da8;\n    border-right: 7px solid transparent;\n    box-sizing: border-box;\n    animation: rotation 1s linear infinite;\n    position: fixed;\n    top: 30%;\n    left: 50%;\n    z-index: 100;\n\n  &::after {\n    content: '';  \n    box-sizing: border-box;\n    position: absolute;\n    left: 0;\n    top: 0;\n    width: 70px;\n    height: 70px;\n    border-radius: 50%;\n    border-bottom: 7px solid #FF3D00;\n    border-left: 7px solid transparent;\n  }\n  \n  @keyframes rotation {\n    0% {\n      transform: rotate(0deg);\n    }\n    100% {\n      transform: rotate(360deg);\n    }\n  } \n}\n\n.permission-table {\n    th, td {\n        padding: 0.3rem 0.5rem;\n    }\n}\n\n.permission-icon {\n    font-size: 20px;\n}\n\n.permission-cat {\n    background: #e2ecff;\n}\n\n.action-disabled {\n    opacity: 0.6;\n    cursor: not-allowed !important;\n}\n.card{\n    .inai-header{\n        text-transform: uppercase;\n        font-weight: bold;\n        background-color: #205da8;\n        color: white;\n    }\n}\n\n\n.inai-border-bottom{\n    border-bottom: dotted #c1bfbf 1px;\n}\n.inai-info-background{\n    background: rgb(242 242 242 / 73%);\n    padding: 25px;\n    border-radius: 10px !important;\n    border: solid 1px #dadada;\n}\n@media (min-width: 1024px) {\n    .inai-border-right{\n        border-right: dotted #c1bfbf 1px;\n    }\n}\n\n.inai-table{\n    thead {\n    tr td{\n    color: #fff;\n    line-height: 1.4;\n    background-color: #205da8;\n    padding-top: 11px;\n    padding-bottom: 11px;\n    }\n}\n}\n.page-item.active .page-link {\n    z-index: 3;\n    color: #fff;\n    background-color: #205da8;\n    border-color: #205da8;\n}\n.page-item.disabled .page-link {\n    color: #6c757d;\n    pointer-events: none;\n    background-color: #fff;\n    border-color: #dee2e6;\n}\n\n\n\n  \n.info-combo > h3 {\n    margin: 3px 0;\n}\n\n.no-margin-bottom {\n    margin-bottom: 0 !important;\n}\n\n.info-combo > h5 {\n    margin: 2px 0 6px 0;\n}\n\n\n/* Messages */\n\n.message-logo {\n    float: left;\n    background: #2da9e9;\n    width: 55px;\n    height: 55px;\n    margin-right: 5px;\n    border-radius: 50%;\n    border: 1px solid rgba(0,0,0,0.1);\n}\n\n.message-logo label {\n    text-align: center;\n    width: 100%;\n    font-size: 35px;\n    color: #fff;\n}\n\n.chat-body {\n  background-color: #fbfcff;\n  margin-top: 10px;\n  margin-bottom: 30px;\n}\n\n.message {\n  position: relative;\n  width: 100%;\n}\n\n.message br {\n  clear: both;\n}\n\n.message .message-body {\n  position: relative;\n  width: auto;\n  max-width: calc(100% - 150px);\n  float: left;\n  background-color: #fff;\n  border-radius: 4px;\n  border: 1px solid #dbe3e8;\n  margin: 0 5px 20px 15px;\n  color: #788288;\n}\n\n.message:after {\n  content: \"\";\n  position: absolute;\n  top: 11px;\n  left: 63px;\n  float: left;\n  z-index: 100;\n  border-top: 10px solid transparent;\n  border-left: none;\n  border-bottom: 10px solid transparent;\n  border-right: 13px solid #fff;\n}\n\n.message:before {\n  content: \"\";\n  position: absolute;\n  top: 10px;\n  left: 62px;\n  float: left;\n  z-index: 99;\n  border-top: 11px solid transparent;\n  border-left: none;\n  border-bottom: 11px solid transparent;\n  border-right: 13px solid #dbe3e8;\n}\n\n.message .medium-image {\n  float: left;\n  margin-left: 10px;\n}\n\n.message .message-info {\n  width: 100%;\n  height: 22px;\n}\n\n.message .message-info > h5 > i {\n  font-size: 11px;\n  font-weight: 700;\n  margin: 0 2px 0 0;\n  color: #a2b8c5;\n}\n\n.message .message-info > h5 {\n  color: #a2b8c5;\n  margin: 8px 0 0 60px;\n  font-size: 12px;\n  float: right;\n  padding-right: 10px;\n}\n\n.message .message-info > h4 {\n  font-size: 14px;\n  font-weight: 600;\n  margin: 7px 13px 0 10px;\n  color: #65addd;\n  float: left;\n}\n\n.message hr {\n  margin: 4px 2%;\n  width: 96%;\n  opacity: 0.75;\n}\n\n.message .message-text {\n  text-align: left;\n  padding: 3px 13px 10px 13px;\n  font-size: 14px;\n  color: #fff;\n}\n\n.message.my-message .message-body {\n  float: right;\n  margin: 0 15px 20px 5px;\n}\n\n.message.my-message:after {\n  content: \"\";\n  position: absolute;\n  top: 11px;\n  left: auto;\n  right: 63px;\n  float: left;\n  z-index: 100;\n  border-top: 10px solid transparent;\n  border-left: 13px solid #fff;\n  border-bottom: 10px solid transparent;\n  border-right: none;\n}\n\n.message.my-message:before {\n  content: \"\";\n  position: absolute;\n  top: 10px;\n  left: auto;\n  right: 62px;\n  float: left;\n  z-index: 99;\n  border-top: 11px solid transparent;\n  border-left: 13px solid #dbe3e8;\n  border-bottom: 11px solid transparent;\n  border-right: none;\n}\n\n.message.my-message .message-info > h5 {\n  float: left;\n  padding-left: 10px;\n  padding-right: 0;\n}\n\n.message.my-message .message-info > h4 {\n  float: right;\n}\n\n.message.info .message-body {\n  background-color: #2da9e9;\n  border: 1px solid #2da9e9;\n  color: #fff;\n}\n\n.message.info:after, .message.info:before {\n  border-right: 13px solid #2da9e9;\n}\n\n.message.success .message-body {\n  background-color: #0ec8a2;\n  border: 1px solid #0ec8a2;\n  color: #fff;\n}\n\n.message.success:after, .message.success:before {\n  border-right: 13px solid #0ec8a2;\n}\n\n.message.warning .message-body {\n  background-color: #ff9e2a;\n  border: 1px solid #ff9e2a;\n  color: #fff;\n}\n\n.message.warning:after, .message.warning:before {\n  border-right: 13px solid #ff9e2a;\n}\n\n.message.danger .message-body {\n  background-color: #f95858;\n  border: 1px solid #f95858;\n  color: #fff;\n}\n\n.message.danger:after, .message.danger:before {\n  border-right: 13px solid #f95858;\n}\n\n.message.dark .message-body {\n  background-color: #314557;\n  border: 1px solid #314557;\n  color: #fff;\n}\n\n.message.dark:after, .message.dark:before {\n  border-right: 13px solid #314557;\n}\n\n.message.info .message-info > h4, .message.success .message-info > h4,\n.message.warning .message-info > h4, .message.danger .message-info > h4,\n.message.dark .message-info > h4 {\n  color: #fff;\n}\n\n.message.info .message-info > h5, .message.info .message-info > h5 > i,\n.message.success .message-info > h5, .message.success .message-info > h5 > i,\n.message.warning .message-info > h5, .message.warning .message-info > h5 > i,\n.message.danger .message-info > h5, .message.danger .message-info > h5 > i,\n.message.dark .message-info > h5, .message.dark .message-info > h5 > i {\n  color: #fff;\n  opacity: 0.9;\n}\n\n.chat-body .reply{\n    margin-left: 80px;\n}\n\n.chat-body .reply .message-text{\n   color: #788288;\n }\n.chat-body .reply .chat-body{\n     background-color: white;\n }\n.chat-body .reply .message-info{\n     color:#000;\n }\n.chat-body .reply .message-info > h4{\n     color:#65addd;;\n }\n \n.chat-body .reply .message-logo {\n     background: #ffa500;\n }\n\n .reply-box{\n    max-width: 700px;\n }\n \n.reply-box textarea{\n    border: none;\n    width: 100%;\n    height: 40px;\n }\n\n .reply-box .message-body{\n    width: 100%;\n }\n\n .reply-box button{\n    float: left;\n }\n\n .react-datepicker-wrapper{\n    width: 100%;\n }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
